<template>
  <div>
    <v-container fluid v-if="!EditdialogUser && !AddVector">
      <v-skeleton-loader :loading="!flagNav" transition="scale-transition" max-height="64" type="table-heading">
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t('Documents_title') }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>

      <!-- โหมด App Knowledge Center (status.enabled): การ์ดเดิมทั้งหมด แค่แหล่งข้อมูลสลับไป Center ผ่าน kccSrc
           + ส่วนเสริมที่มี v-if="centerMode" (banner / alert ไม่มี Admin key / ตัวกรองของเรา–ได้รับแชร์ / คอลัมน์เจ้าของ–สิทธิ์ / Policy–แชร์)
           ปิดโหมด ⇒ ส่วนเสริมไม่ render และทุก call ไป $call เดิม -->
      <v-alert v-if="centerMode" type="info" variant="tonal" density="compact" icon="mdi-book-lock-outline" class="mt-4">
        <div class="d-flex flex-wrap align-center ga-2">
          <span>{{ $t('kccModeBanner') }}</span>
          <v-chip v-if="kccStatus && kccStatus.baseUrlDisplay" size="small" label variant="outlined" prepend-icon="mdi-link-variant">
            {{ kccStatus.baseUrlDisplay }}
          </v-chip>
        </div>
      </v-alert>
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" md="5">
              <!-- <v-card variant="outlined" class="pa-2 search-panel">
                <v-row no-gutters>
                  <v-col cols="9" class="pa-2">
                    <v-text-field
                      :label="'Document Name'"
                      v-model="searchVectorDBName"
                      @keydown.enter="Search"
                      density="comfortable"
                      variant="outlined"
                      prepend-inner-icon="mdi-clipboard-text-search-outline"
                      hide-details
                      clearable
                      color="primary"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" class="pa-2 d-flex align-center justify-end">
                    <v-btn
                      color="primary"
                      class="ml-2"
                      variant="elevated"
                      @click="Search"
                    >
                      <v-icon start>mdi-magnify</v-icon>
                      Search
                    </v-btn>
                  </v-col>
                </v-row>              
              </v-card> -->
              <div class="page-title">{{ 'Documents' }}</div>
            </v-col>
            <v-col cols="12" md="7" class="d-flex justify-end">
              <v-btn variant="elevated" class="custom-document-btn" prepend-icon="mdi-api" @click="newsConnectionOpen = true">News &amp; Activities</v-btn>
            </v-col>
          </v-row>
          <!-- โหมด Center แต่ยังไม่มี Admin key ⇒ บอกให้ไปตั้งค่า · ไม่ยิง Center และไม่โชว์แท็บ/ตาราง -->
          <v-alert v-if="kccNotReady" type="warning" variant="tonal" density="comfortable" icon="mdi-key-alert-outline" class="mt-4">
            {{ $t('kccNotReady') }}
            <template #append>
              <v-btn to="/setup" variant="outlined" color="warning" class="text-none" prepend-icon="mdi-cog-outline">
                {{ $t('kccOpenSetup') }}
              </v-btn>
            </template>
          </v-alert>
        </v-card-text>

        <template v-if="!kccNotReady">
        <!-- Title Tabs -->
        <v-tabs v-model="selectedTitle" show-arrows density="compact" class="title-tabs mx-4">
          <v-tab v-for="tab in titleTabs" :key="tab" :value="tab === 'Others' ? '__OTHERS__' : tab" class="title-tab">
            {{ tab.replace(/_/g, ' ') }}
          </v-tab>
        </v-tabs>

        <div v-if="availableSubTitles.length > 0" class="subtitle-chips mx-4 mt-2 mb-1">
          <v-chip-group v-model="selectedSubTitle" mandatory>
            <v-chip value="All" variant="elevated" :color="selectedSubTitle === 'All' ? '#4B2869' : undefined" :text-color="selectedSubTitle === 'All' ? 'white' : undefined" class="subtitle-chip" rounded="pill" size="small">
              All
            </v-chip>
            <v-chip v-for="sub in availableSubTitles" :key="sub" :value="sub" variant="elevated" :color="selectedSubTitle === sub ? '#4B2869' : undefined" :text-color="selectedSubTitle === sub ? 'white' : undefined" class="subtitle-chip" rounded="pill" size="small">
              {{ sub.replace(/_/g, ' ') }}
            </v-chip>
          </v-chip-group>
        </div>

        <!-- Search, Add, Filter row -->
        <v-row align="center" class="mx-4 mt-2 mb-1" no-gutters>
          <v-col class="d-flex flex-wrap align-center gap-2">
            <v-text-field v-model="searchVectorDBName" placeholder="Search" variant="outlined" density="comfortable" class="custom-search-field" hide-details style="max-width: 300px;">
              <template v-slot:prepend-inner>
                <v-icon color="#001763" size="25">mdi-magnify</v-icon>
              </template>
            </v-text-field>

            <v-btn v-if="canAdd" variant="elevated" class="custom-document-btn" @click="Add()">
              <v-icon size="23" class="mr-2">mdi-plus</v-icon>
              <span class="btn-text">{{ $t("add") }}</span>
            </v-btn>

            <v-btn v-if="canAdd || canEdit" variant="elevated" class="custom-document-btn" @click="openMetaDocCategoriesDialog">
              <v-icon size="23" class="mr-2">mdi-shape</v-icon>
              <span class="btn-text">Categories</span>
            </v-btn>

            <v-select
              v-model="statusFilter"
              :items="statusFilterOptions"
              item-title="title"
              item-value="value"
              variant="outlined"
              density="comfortable"
              hide-details
              style="max-width: 160px;"
            ></v-select>

            <!-- โหมด Center: ทั้งหมด / ของเรา / ได้รับแชร์ — กรองฝั่ง client จาก scope ของแถว (ตัวนับหลังกรองสถานะ) -->
            <v-btn-toggle
              v-if="centerMode"
              v-model="kccSourceFilter"
              mandatory
              divided
              density="comfortable"
              variant="outlined"
              color="primary"
            >
              <v-btn value="all" class="text-none">
                {{ $t('kccAll') }}<span class="ml-2 text-caption font-weight-bold">{{ kccSourceCounts.all }}</span>
              </v-btn>
              <v-btn value="own" class="text-none" prepend-icon="mdi-domain">
                {{ $t('kccOwnDocs') }}<span class="ml-2 text-caption font-weight-bold">{{ kccSourceCounts.own }}</span>
              </v-btn>
              <v-btn value="shared" class="text-none" prepend-icon="mdi-share-variant">
                {{ $t('kccSharedDocs') }}<span class="ml-2 text-caption font-weight-bold">{{ kccSourceCounts.shared }}</span>
              </v-btn>
            </v-btn-toggle>

            <!-- <v-btn color="#4B2869" variant="elevated" class="filter-btn" icon @click="toggleFilterDrawer">
              <v-icon color="white" size="25">mdi-filter-variant</v-icon>
            </v-btn> -->
          </v-col>
        </v-row>

        <div class="ma-4 metadoc-table-container">
          <v-data-table-server
          v-model:options="options"
          :items-per-page="-1"
          :items-per-page-options="[{ value: -1, title: 'All' }]"
          :items-length="searchTotalTable"
          :items="filteredDataTable"
          :headers="headers"
          :loading="loadingTable"
          class="metadoc-table"
          density="comfortable"
          fixed-header
        >
            <template v-slot:bottom></template>
            <template v-slot:item="{ item }">
              <tr>
                <!-- Actions: Edit, Manage Knowledge, Delete -->
                <td style="text-align: center">
                  <div class="d-flex align-center justify-center ga-2">
                    <!-- โหมด Center scope view ⇒ ปุ่มนี้เปิด dialog แบบดูอย่างเดียว (kccCanEditRow) -->
                    <v-btn size="small" variant="outlined" color="primary" class="action-btn" @click="Edit(item)">
                      <v-icon size="16">{{ kccCanEditRow(item) ? 'mdi-pencil' : 'mdi-eye' }}</v-icon>
                      <v-tooltip activator="parent" location="top">{{ kccCanEditRow(item) ? 'Edit' : 'View' }}</v-tooltip>
                    </v-btn>
                    <v-btn size="small" variant="outlined" color="primary" class="action-btn" @click="ManageKnowledge(item)">
                      <v-icon size="16">mdi-book-open-variant</v-icon>
                      <v-tooltip activator="parent" location="top">{{ kccCanEditRow(item) ? 'Manage Knowledge' : 'View Knowledge' }}</v-tooltip>
                    </v-btn>
                    <!-- โหมด Center: Policy (dialog มีแท็บ แชร์ อยู่ในตัว) เฉพาะเอกสารของเรา (scope owner) + role 0/1 -->
                    <v-btn v-if="kccCanManageAccess(item)" size="small" variant="outlined" color="primary" class="action-btn" @click="openKccPolicyShare(item)">
                      <v-icon size="16">mdi-shield-key-outline</v-icon>
                      <v-tooltip activator="parent" location="top">{{ $t('kccPolicy') }}</v-tooltip>
                    </v-btn>
                    <v-btn v-if="canDelete && kccCanDeleteRow(item)" size="small" variant="outlined" :color="btnDisableDelete(item) ? 'grey-lighten-1' : 'error'" class="action-btn" @click="DeleteByName(item.vectorDBName)" :disabled="btnDisableDelete(item)">
                      <v-icon size="16">mdi-delete-outline</v-icon>
                      <v-tooltip activator="parent" location="top">{{ btnDisableDelete(item) ? 'You can only delete items you created' : 'Delete' }}</v-tooltip>
                    </v-btn>
                  </div>
                </td>
                <!-- Item ID -->
                <td style="text-align: center">{{ item.itemID || '-' }}</td>
                <!-- โหมด Center: บริษัทเจ้าของ + สิทธิ์ของเราต่อเอกสาร (ลำดับตรงกับ headers) -->
                <td v-if="centerMode" style="text-align: left; padding-left: 16px">{{ kccOwnerName(item) }}</td>
                <td v-if="centerMode" style="text-align: center">
                  <div class="py-1">
                    <v-chip size="small" label variant="tonal" :color="kccScopeColor(item)" :prepend-icon="kccScopeIcon(item)">
                      {{ kccScopeLabel(item) }}
                    </v-chip>
                    <div v-if="kccSourceOf(item) === 'shared'" class="text-caption text-medium-emphasis mt-1">
                      {{ $t('kccSharedFrom', { name: kccOwnerName(item) }) }}
                    </div>
                  </div>
                </td>
                <!-- Status -->
                <td style="text-align: center">
                  <span :style="{ color: item.activeStatus ? '#4CAF50' : '#9E9E9E', fontWeight: 500 }">
                    {{ item.activeStatus ? 'Active' : 'Inactive' }}
                  </span>
                </td>
                <!-- Process -->
                <td style="text-align: center; padding: 12px">
                  <div class="d-flex justify-center">
                    <v-chip
                      v-if="item.processingStatus"
                      :color="processingChipColor(item.processingStatus)"
                      variant="flat"
                      size="small"
                      class="status-chip status-chip-processing"
                    >
                      <v-icon size="14" class="status-chip-icon">
                        {{ processingChipIcon(item.processingStatus) }}
                      </v-icon>
                      <span class="status-text">{{ item.processingStatus }}</span>
                    </v-chip>
                    <span v-else style="color: #9E9E9E">-</span>
                  </div>
                </td>
                <!-- Product Category -->
                <td style="text-align: left; padding-left: 16px">{{ item.title ? item.title.replace(/_/g, ' ') : '-' }}</td>
                <!-- Product Type — 1 เอกสารมีได้หลาย type ⇒ โชว์ทุกอันเป็น tag
                     ค่ามาจาก productTypeNames (backend กาง ProductTypeIds เป็นชื่อให้แล้ว) -->
                <td style="text-align: left; padding-left: 16px">
                  <div v-if="productTypeTags(item).length" class="type-tag-cell">
                    <v-chip
                      v-for="tag in productTypeTags(item)"
                      :key="tag"
                      size="x-small"
                      variant="tonal"
                      color="primary"
                    >{{ tag }}</v-chip>
                  </div>
                  <span v-else style="color: #9E9E9E">-</span>
                </td>
                <!-- Product Subtype — เช่นเดียวกับ Product Type: 1 เอกสารผูกได้หลาย subtype
                     ค่ามาจาก productSubtypeNames (backend กาง ProductSubtypeIds เป็นชื่อให้แล้ว)
                     ตัวแรกในลิสต์ = "ตัวหลัก" ที่ลงคอลัมน์ ProductSubtype เดิม -->
                <td style="text-align: left; padding-left: 16px">
                  <div v-if="productSubtypeTags(item).length" class="type-tag-cell">
                    <v-chip
                      v-for="tag in productSubtypeTags(item)"
                      :key="tag"
                      size="x-small"
                      variant="tonal"
                      color="teal"
                    >{{ tag }}</v-chip>
                  </div>
                  <span v-else style="color: #9E9E9E">-</span>
                </td>
                <!-- Name EN -->
                <td style="text-align: left; padding-left: 16px">{{ item.nameEN || '-' }}</td>
                <!-- Name TH -->
                <td style="text-align: left; padding-left: 16px">{{ item.nameTH || '-' }}</td>
                <!-- Keyword -->
                <td style="text-align: left; padding-left: 16px">{{ item.keyword || '-' }}</td>
                <!-- Prompt -->
                <td style="text-align: left; padding-left: 16px" class="prompt-cell">{{ item.prompt || '-' }}</td>
                <!-- Last Update -->
                <td style="text-align: left; padding-left: 16px">{{ formatEffectiveDate(item.lastUpdate) || '-' }}</td>
              </tr>
            </template>
          </v-data-table-server>
        </div>
        </template>
      </v-card>
    </v-container>

    <!-- Loading Please Wait... -->
    <!-- <v-dialog v-model="dialog" persistent width="300">
      <v-card color="#1976D2" dark>
        <v-card-text class="white--text">
          Loading Please Wait...
          <v-progress-linear
            indeterminate
            color="#FAA91B"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog> -->

    <v-overlay :model-value="dialog" class="align-center justify-center">
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular indeterminate size="64" color="primary" class="mb-4"></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>

    <!-- Filter Navigation Drawer - Full Page Overlay -->
    <v-navigation-drawer v-model="filterDrawer" location="right" temporary scrim width="400" class="filter-drawer-fullpage">
      <v-card flat height="100%" class="filter-drawer-card">
        <!-- Header with Icon, Text and Close Button -->
        <v-card-title class="d-flex align-center justify-space-between px-4 py-2">
          <div class="d-flex align-center">
            <img :src="drawerIcon" alt="Filter" class="drawer-icon mr-2" />
            <span class="text-h7 font-weight-bold">Filter</span>
          </div>
          <div class="d-flex align-center gap-2">
            <v-btn variant="text" size="small" @click="clearFilters" class="text-caption"> Clear All </v-btn>
            <v-btn icon variant="text" @click="filterDrawer = false" size="small">
              <v-icon size="24" color="#903F98">mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <hr style="border: none; border-top: 1px solid #ededed" class="mx-4" />

        <v-card-text class="pa-4">
          <!-- Status Section -->
          <div class="mb-1">
            <h4 class="filter-section-title">Status</h4>
            <v-checkbox v-model="statusFilters.all" label="All" density="compact" hide-details class="mb-1 custom-checkbox" :color="statusFilters.all ? '#76237E' : '#C9C9C9'"></v-checkbox>
            <v-checkbox v-model="statusFilters.active" label="Active" density="compact" hide-details class="mb-1 custom-checkbox" :color="statusFilters.active ? '#76237E' : '#C9C9C9'"></v-checkbox>
            <v-checkbox
              v-model="statusFilters.inactive"
              label="Inactive"
              density="compact"
              hide-details
              class="mb-1 custom-checkbox"
              :color="statusFilters.inactive ? '#76237E' : '#C9C9C9'"
            ></v-checkbox>
          </div>

          <hr style="border: none; border-top: 1px solid #ededed" class="my-4" />

          <!-- Knowledge Category Section -->
          <div class="mb-4">
            <h4 class="filter-section-title mb-3">Knowledge Category</h4>
            <v-select
              v-model="selectedCategory"
              :items="knowledgeCategories"
              item-title="name"
              item-value="value"
              placeholder="Select Category"
              variant="outlined"
              density="compact"
              hide-details
              clearable
              :menu-props="{
                attach: false,
                zIndex: 9999,
                maxHeight: '200px',
                offsetY: true,
              }"
              class="custom-category-dropdown"
            >
            </v-select>
          </div>
          <hr style="border: none; border-top: 1px solid #ededed" class="my-6" />
          <!-- Effective Start Date Section -->
          <div class="mb-4">
            <h4 class="filter-section-title mb-3">Effective Start Date</h4>
            <VueDatePicker
              :model-value="effectiveStartDate"
              @update:model-value="onEffectiveStartChange"
              placeholder="Start date"
              is24
              :enable-time-picker="true"
              :format="'dd/MM/yyyy HH:mm'"
              text-input
              auto-apply
              :max-date="effectiveEndDate"
              :teleport="true"
              :ui="{ menu: 'side-by-side-datetime-menu' }"
              :max-time="{ hours: 23, minutes: 59 }"
              :start-time="{ hours: 0, minutes: 0 }"
              no-hours-overlay
              no-minutes-overlay
              class="custom-datetime-picker"
            >
              <template #time-picker="{ time, updateTime }">
                <NonLoopTimePicker :time="time" :update-time="updateTime" />
              </template>
            </VueDatePicker>
          </div>

          <!-- Effective End Date Section -->
          <div class="mb-4">
            <h4 class="filter-section-title mb-3">Effective End Date</h4>
            <VueDatePicker
              :model-value="effectiveEndDate"
              @update:model-value="onEffectiveEndChange"
              placeholder="End date"
              is24
              :enable-time-picker="true"
              :format="'dd/MM/yyyy HH:mm'"
              text-input
              auto-apply
              :min-date="effectiveStartDate"
              :teleport="true"
              :ui="{ menu: 'side-by-side-datetime-menu' }"
              :max-time="{ hours: 23, minutes: 59 }"
              :start-time="{ hours: 0, minutes: 0 }"
              no-hours-overlay
              no-minutes-overlay
              class="custom-datetime-picker"
            >
              <template #time-picker="{ time, updateTime }">
                <NonLoopTimePicker :time="time" :update-time="updateTime" />
              </template>
            </VueDatePicker>
          </div>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>

    <!-- Add New Item Dialog -->
    <v-dialog v-model="dialogAddItem" persistent max-width="720px">
      <v-card class="add-item-dialog-card">
        <!-- Pink gradient header -->
        <div class="add-item-dialog-header">
          <h2>Add New Item</h2>
        </div>

        <v-card-text class="pa-6">
          <v-form ref="addItemForm">
          <!-- Section heading: dynamic selected title -->
          <h3 class="mb-4" style="font-weight: 600; font-size: 16px; color: #333;">
            {{ showDetailHeader ? `${selectedTitleLabel} Detail` : selectedTitleLabel }}
          </h3>

          <!-- Default product fields: hidden for simple & troubleshooting tabs -->
          <div class="mb-4" v-if="showProductFields">
            <v-row>
               <v-col cols="12" md="4">
                 <v-select
                   v-model="newItem.productCategory"
                   :items="newItemProductCategories"
                   label="Product_category*"
                   :rules="[newItemRules.required]"
                   variant="outlined"
                   density="comfortable"
                   hide-details="auto"
                   :disabled="selectedSubTitle && selectedSubTitle !== 'All'"
                   @update:modelValue="onNewItemCategoryChange"
                 ></v-select>
               </v-col>
               <v-col v-if="showProductTypeField" cols="12" md="4">
                 <!-- 1 Product_category มีได้หลาย Product_type ⇒ เลือกได้หลายอัน
                      v-select multiple ของ Vuetify แสดงเป็น checkbox ในเมนูให้เอง
                      ตัวแรกที่เลือก = "ตัวหลัก" ที่ backend เขียนลงคอลัมน์ SubTitle เดิม -->
                 <v-select
                   v-model="newItem.productTypes"
                   :items="newItemProductTypes"
                   label="Product_type"
                   :rules="[validateNewItemProductType]"
                   variant="outlined"
                   density="comfortable"
                   hide-details="auto"
                   multiple
                   chips
                   closable-chips
                   :disabled="newItemProductTypes.length === 0"
                  @update:modelValue="onNewItemTypeChange"
                ></v-select>
              </v-col>
              <v-col v-if="showFullProductFields" cols="12" md="4">
                <v-select
                  v-model="newItem.productSubtypes"
                  :items="newItemProductSubtypes"
                  label="Product_subtype*"
                  :rules="[validateNewItemProductSubtype]"
                  variant="outlined"
                  density="comfortable"
                  hide-details="auto"
                  multiple
                  chips
                  closable-chips
                  :disabled="newItemProductSubtypes.length === 0"
                ></v-select>
              </v-col>
              <!-- #746 ปีภาษี: เลือกได้ปีปัจจุบัน ±1 · ไม่บังคับ กด x ล้างเป็นค่าว่างได้ -->
              <v-col v-if="selectedTitle === 'Tax'" cols="12" md="4">
                <v-select
                  v-model="newItem.taxYear"
                  :items="newItemTaxYearOptions"
                  label="Tax_year"
                  variant="outlined"
                  density="comfortable"
                  hide-details="auto"
                  clearable
                ></v-select>
              </v-col>
            </v-row>
          </div>

          <div class="mb-4" v-if="showFinancialTransactionFields">
            <v-row>
               <v-col cols="12" md="4">
                 <v-select
                   v-model="newItem.productType"
                   :items="financialTransactionTypes"
                   label="Product_type*"
                   :rules="[newItemRules.required]"
                   variant="outlined"
                   density="comfortable"
                   hide-details="auto"
                   :disabled="selectedSubTitle && selectedSubTitle !== 'All'"
                 ></v-select>
               </v-col>
             </v-row>
           </div>

          <!-- Troubleshooting fields: category + type comboboxes -->
          <div class="mb-4" v-if="selectedTitle === 'Troubleshooting'">
            <v-row>
              <v-col cols="12" md="6">
                <v-combobox
                  v-model="newItem.tsCategory"
                  :items="troubleshootingCategories"
                  label="category*"
                  :rules="[newItemRules.required]"
                  variant="outlined"
                  density="comfortable"
                  hide-details="auto"
                ></v-combobox>
              </v-col>
              <v-col cols="12" md="6">
                <v-combobox
                  v-model="newItem.tsType"
                  :items="troubleshootingTypes"
                  label="type*"
                  :rules="[newItemRules.required]"
                  variant="outlined"
                  density="comfortable"
                  hide-details="auto"
                ></v-combobox>
              </v-col>
            </v-row>
          </div>

          <!-- Name_TH -->
          <v-text-field
            v-model="newItem.nameTH"
            label="Name_TH*"
            :rules="[newItemRules.required]"
            variant="outlined"
            density="comfortable"
            hide-details="auto"
            class="mb-4"
          ></v-text-field>

          <!-- Name_EN -->
          <v-text-field
            v-model="newItem.nameEN"
            label="Name_EN*"
            :rules="[newItemRules.required]"
            variant="outlined"
            density="comfortable"
            hide-details="auto"
            class="mb-4"
          ></v-text-field>

          <!-- Customer-confirmed Product fields: local UI demo until the API contract is approved -->
          <div v-if="showFullProductFields" class="product-display-fields mb-4">
            <v-text-field
              v-model="newItem.nameCN"
              label="Name_CN"
              variant="outlined"
              density="comfortable"
              hide-details
              class="mb-4"
            ></v-text-field>

            <v-textarea
              v-model="newItem.keyword"
              label="Keyword"
              variant="outlined"
              density="comfortable"
              hide-details
              rows="3"
              class="mb-4"
            ></v-textarea>

            <v-textarea
              v-model="newItem.prompt"
              label="Prompt"
              variant="outlined"
              density="comfortable"
              hide-details
              rows="3"
              class="mb-4"
            ></v-textarea>

            <div class="product-language-image-row mb-4">
              <div v-for="language in productImageLanguages" :key="`new-${language.key}`" class="product-language-image-field">
                <label :for="`new-product-image-${language.key}`" class="product-language-label">Image_{{ language.label }}</label>
                <label
                  :for="`new-product-image-${language.key}`"
                  class="product-language-upload-button"
                  :class="{ 'product-language-upload-button-has-preview': newItem.imagePreviews[language.key].length }"
                  @dragover.prevent
                  @drop.prevent="onProductLanguageImagesDropped('newItem', language.key, $event)"
                >
                  <template v-if="newItem.imagePreviews[language.key].length">
                    <v-img
                      :src="newItem.imagePreviews[language.key][0].src"
                      class="product-image-preview-surface"
                      contain
                      :alt="`${language.label} product image preview`"
                    ></v-img>
                    <span class="product-image-preview-overlay">
                      <span>{{ newItem.imagePreviews[language.key][0].existing ? 'Current image' : 'Selected image' }}</span>
                      <small>Click to replace</small>
                    </span>
                    <button
                      v-if="!newItem.imagePreviews[language.key][0].existing"
                      type="button"
                      class="product-image-remove"
                      :aria-label="`Remove ${language.label} image`"
                      @click.stop.prevent="removeProductLanguageImage('newItem', language.key, 0)"
                    >
                      <v-icon size="16">mdi-close</v-icon>
                    </button>
                  </template>
                  <template v-else>
                    <v-icon size="17">mdi-camera-outline</v-icon>
                    <span class="product-language-upload-copy">
                      <span class="product-language-upload-primary">Click to upload</span>
                      <span class="product-language-upload-secondary"> or drag and drop</span>
                    </span>
                  </template>
                  <input
                    :id="`new-product-image-${language.key}`"
                    type="file"
                    class="product-image-upload-input"
                    accept="image/*"
                    @change="onProductLanguageImagesSelected('newItem', language.key, $event.target.files)"
                  />
                </label>
              </div>
            </div>

            <v-checkbox
              v-model="newItem.isTaxPlanning"
              label="Tax Planning"
              color="primary"
              density="comfortable"
              hide-details
              class="product-tax-planning mb-3"
            ></v-checkbox>

            <div v-if="newItem.isTaxPlanning" class="product-key-highlight-panel">
              <div class="product-key-highlight-title">Key Highlight</div>
              <div class="product-key-highlight-tabs" role="tablist" aria-label="Key Highlight language">
                <button
                  v-for="language in productImageLanguages"
                  :key="`new-highlight-${language.key}`"
                  type="button"
                  role="tab"
                  :aria-selected="newItem.keyHighlightLanguage === language.key"
                  :class="{ 'product-key-highlight-tab-active': newItem.keyHighlightLanguage === language.key }"
                  class="product-key-highlight-tab"
                  @click="newItem.keyHighlightLanguage = language.key"
                >{{ language.label }}</button>
              </div>
              <v-textarea
                v-model="newItem.keyHighlights[newItem.keyHighlightLanguage]"
                :placeholder="`Key Highlight (${newItem.keyHighlightLanguage.toUpperCase()})`"
                :aria-label="`Key Highlight (${newItem.keyHighlightLanguage.toUpperCase()})`"
                variant="outlined"
                density="comfortable"
                hide-details
                rows="4"
                class="product-key-highlight-textarea mb-4"
              ></v-textarea>
              <!-- <v-text-field
                v-model="newItem.linkToBuy"
                label="Link to buy"
                placeholder="https://"
                variant="outlined"
                density="comfortable"
                hide-details
              ></v-text-field> -->
            </div>
          </div>

          <!-- Keyword (not required) -->
          <v-textarea
            v-if="!showFullProductFields"
            v-model="newItem.keyword"
            label="Keyword"
            variant="outlined"
            density="comfortable"
            hide-details
            rows="3"
          ></v-textarea>

          <!-- Prompt (not required) -->
          <v-textarea
            v-if="!showFullProductFields"
            v-model="newItem.prompt"
            label="Prompt"
            variant="outlined"
            density="comfortable"
            hide-details
            rows="3"
            class="mt-4"
          ></v-textarea>
          </v-form>
        </v-card-text>

        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn variant="text" color="#f0960a" @click="closeAddItemDialog">Cancel</v-btn>
          <v-btn v-if="canAdd" variant="elevated" color="#1976D2" @click="SaveNewItem">
            <v-icon start>mdi-content-save</v-icon>
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Edit Item Dialog -->
    <v-dialog v-model="dialogEditItem" persistent max-width="720px">
      <v-card class="add-item-dialog-card">
        <!-- Pink gradient header -->
        <div class="add-item-dialog-header">
          <h2>{{ canEdit && !kccReadOnly ? 'Edit Item' : 'View Item' }}</h2>
        </div>

        <v-card-text class="pa-6">
          <!-- โหมด Center: เอกสารที่ได้รับแชร์แบบดู ⇒ ฟอร์มอ่านอย่างเดียว (kccReadOnly ตั้งใน Edit()) -->
          <v-alert v-if="kccReadOnly" type="info" variant="tonal" density="compact" icon="mdi-eye-outline" class="mb-4">
            {{ $t('kccViewOnly') }}
          </v-alert>
          <v-form ref="editItemForm" :disabled="kccReadOnly">
          <!-- Section heading: dynamic selected title -->
          <h3 class="mb-4" style="font-weight: 600; font-size: 16px; color: #333;">
            {{ showDetailHeader ? `${selectedTitleLabel} Detail` : selectedTitleLabel }}
          </h3>

          <!-- Default product fields: hidden for simple & troubleshooting tabs -->
          <div class="mb-4" v-if="showProductFields">
            <v-row>
              <v-col cols="12" md="4">
                <v-select
                  v-model="editItem.productCategory"
                  :items="editItemProductCategories"
                  label="Product_category*"
                  :rules="[newItemRules.required]"
                  variant="outlined"
                  density="comfortable"
                  hide-details="auto"
                  disabled
                ></v-select>
              </v-col>
               <v-col v-if="showProductTypeField" cols="12" md="4">
                 <!-- ปลดล็อกจาก disabled เดิม — โครงใหม่ผูกด้วย ID ใน ProductTypeIds จึงแก้ได้แล้ว
                      (ก่อนหน้านี้ปิดไว้เพราะเปลี่ยนสตริงแล้วเอกสารหลุดการ join) -->
                 <v-select
                   v-model="editItem.productTypes"
                   :items="editItemProductTypes"
                   label="Product_type"
                   :rules="[validateEditItemProductType]"
                   variant="outlined"
                   density="comfortable"
                   hide-details="auto"
                   multiple
                   chips
                   closable-chips
                   :disabled="editItemProductTypes.length === 0"
                   @update:modelValue="onEditItemTypeChange"
                ></v-select>
              </v-col>
              <v-col v-if="showFullProductFields" cols="12" md="4">
                <v-select
                  v-model="editItem.productSubtypes"
                  :items="editItemProductSubtypes"
                  label="Product_subtype*"
                  :rules="[validateEditItemProductSubtype]"
                  variant="outlined"
                  density="comfortable"
                  hide-details="auto"
                  multiple
                  chips
                  closable-chips
                  :disabled="editItemProductSubtypes.length === 0"
                ></v-select>
              </v-col>
              <!-- #746 ปีภาษี: เลือกได้ปีปัจจุบัน ±1 · ไม่บังคับ กด x ล้างเป็นค่าว่างได้ -->
              <v-col v-if="selectedTitle === 'Tax'" cols="12" md="4">
                <v-select
                  v-model="editItem.taxYear"
                  :items="editItemTaxYearOptions"
                  label="Tax_year"
                  variant="outlined"
                  density="comfortable"
                  hide-details="auto"
                  clearable
                ></v-select>
              </v-col>
            </v-row>
          </div>

          <div class="mb-4" v-if="showFinancialTransactionFields">
            <v-row>
              <v-col cols="12" md="4">
                <v-select
                  v-model="editItem.productType"
                  :items="financialTransactionTypes"
                  label="Product_type*"
                  :rules="[newItemRules.required]"
                  variant="outlined"
                  density="comfortable"
                  hide-details="auto"
                  disabled
                ></v-select>
              </v-col>
            </v-row>
          </div>

          <!-- Troubleshooting fields: category + type comboboxes -->
          <div class="mb-4" v-if="selectedTitle === 'Troubleshooting'">
            <v-row>
              <v-col cols="12" md="6">
                <v-combobox
                  v-model="editItem.tsCategory"
                  :items="troubleshootingCategories"
                  label="category*"
                  :rules="[newItemRules.required]"
                  variant="outlined"
                  density="comfortable"
                  hide-details="auto"
                ></v-combobox>
              </v-col>
              <v-col cols="12" md="6">
                <v-combobox
                  v-model="editItem.tsType"
                  :items="troubleshootingTypes"
                  label="type*"
                  :rules="[newItemRules.required]"
                  variant="outlined"
                  density="comfortable"
                  hide-details="auto"
                ></v-combobox>
              </v-col>
            </v-row>
          </div>

          <!-- Name_TH -->
          <v-text-field
            v-model="editItem.nameTH"
            label="Name_TH*"
            :rules="[newItemRules.required]"
            variant="outlined"
            density="comfortable"
            hide-details="auto"
            class="mb-4"
          ></v-text-field>

          <!-- Name_EN -->
          <v-text-field
            v-model="editItem.nameEN"
            label="Name_EN*"
            :rules="[newItemRules.required]"
            variant="outlined"
            density="comfortable"
            hide-details="auto"
            class="mb-4"
          ></v-text-field>

          <!-- Customer-confirmed Product fields: local UI demo until the API contract is approved -->
          <div v-if="showFullProductFields" class="product-display-fields mb-4">
            <v-text-field
              v-model="editItem.nameCN"
              label="Name_CN"
              variant="outlined"
              density="comfortable"
              hide-details
              class="mb-4"
            ></v-text-field>

            <v-textarea
              v-model="editItem.keyword"
              label="Keyword"
              variant="outlined"
              density="comfortable"
              hide-details
              rows="3"
              class="mb-4"
            ></v-textarea>

            <v-textarea
              v-model="editItem.prompt"
              label="Prompt"
              variant="outlined"
              density="comfortable"
              hide-details
              rows="3"
              class="mb-4"
            ></v-textarea>

            <div class="product-language-image-row mb-4">
              <div v-for="language in productImageLanguages" :key="`edit-${language.key}`" class="product-language-image-field">
                <label :for="`edit-product-image-${language.key}`" class="product-language-label">Image_{{ language.label }}</label>
                <label
                  :for="`edit-product-image-${language.key}`"
                  class="product-language-upload-button"
                  :class="{ 'product-language-upload-button-has-preview': editItem.imagePreviews[language.key].length }"
                  @dragover.prevent
                  @drop.prevent="!kccReadOnly && onProductLanguageImagesDropped('editItem', language.key, $event)"
                >
                  <template v-if="editItem.imagePreviews[language.key].length">
                    <v-img
                      :src="editItem.imagePreviews[language.key][0].src"
                      class="product-image-preview-surface"
                      contain
                      :alt="`${language.label} product image preview`"
                    ></v-img>
                    <span class="product-image-preview-overlay">
                      <span>{{ editItem.imagePreviews[language.key][0].existing ? 'Current image' : 'Selected image' }}</span>
                      <small>Click to replace</small>
                    </span>
                    <button
                      v-if="!editItem.imagePreviews[language.key][0].existing"
                      type="button"
                      class="product-image-remove"
                      :aria-label="`Remove ${language.label} image`"
                      @click.stop.prevent="removeProductLanguageImage('editItem', language.key, 0)"
                    >
                      <v-icon size="16">mdi-close</v-icon>
                    </button>
                  </template>
                  <template v-else>
                    <v-icon size="17">mdi-camera-outline</v-icon>
                    <span class="product-language-upload-copy">
                      <span class="product-language-upload-primary">Click to upload</span>
                      <span class="product-language-upload-secondary"> or drag and drop</span>
                    </span>
                  </template>
                  <input
                    :id="`edit-product-image-${language.key}`"
                    type="file"
                    class="product-image-upload-input"
                    accept="image/*"
                    :disabled="kccReadOnly"
                    @change="onProductLanguageImagesSelected('editItem', language.key, $event.target.files)"
                  />
                </label>
              </div>
            </div>

            <v-checkbox
              v-model="editItem.isTaxPlanning"
              label="Tax Planning"
              color="primary"
              density="comfortable"
              hide-details
              class="product-tax-planning mb-3"
            ></v-checkbox>

            <div v-if="editItem.isTaxPlanning" class="product-key-highlight-panel">
              <div class="product-key-highlight-title">Key Highlight</div>
              <div class="product-key-highlight-tabs" role="tablist" aria-label="Key Highlight language">
                <button
                  v-for="language in productImageLanguages"
                  :key="`edit-highlight-${language.key}`"
                  type="button"
                  role="tab"
                  :aria-selected="editItem.keyHighlightLanguage === language.key"
                  :class="{ 'product-key-highlight-tab-active': editItem.keyHighlightLanguage === language.key }"
                  class="product-key-highlight-tab"
                  @click="editItem.keyHighlightLanguage = language.key"
                >{{ language.label }}</button>
              </div>
              <v-textarea
                v-model="editItem.keyHighlights[editItem.keyHighlightLanguage]"
                :placeholder="`Key Highlight (${editItem.keyHighlightLanguage.toUpperCase()})`"
                :aria-label="`Key Highlight (${editItem.keyHighlightLanguage.toUpperCase()})`"
                variant="outlined"
                density="comfortable"
                hide-details
                rows="4"
                class="product-key-highlight-textarea mb-4"
              ></v-textarea>
              <!-- <v-text-field
                v-model="editItem.linkToBuy"
                label="Link to buy"
                placeholder="https://"
                variant="outlined"
                density="comfortable"
                hide-details
              ></v-text-field> -->
            </div>
          </div>

          <!-- Keyword (not required) -->
          <v-textarea
            v-if="!showFullProductFields"
            v-model="editItem.keyword"
            label="Keyword"
            variant="outlined"
            density="comfortable"
            hide-details
            rows="3"
          ></v-textarea>

          <!-- Prompt (not required) -->
          <v-textarea
            v-if="!showFullProductFields"
            v-model="editItem.prompt"
            label="Prompt"
            variant="outlined"
            density="comfortable"
            hide-details
            rows="3"
            class="mt-4"
          ></v-textarea>
          </v-form>
        </v-card-text>

        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn variant="text" color="#f0960a" @click="closeEditItemDialog">{{ isViewOnly || kccReadOnly ? 'Close' : 'Cancel' }}</v-btn>
          <v-btn v-if="canEdit && !kccReadOnly" variant="elevated" color="#1976D2" @click="SaveEditItem">
            <v-icon start>mdi-content-save</v-icon>
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ════════ Meta Document Category Management Dialog ════════ -->
    <v-dialog v-model="metaDocCategoriesDialog" max-width="1200px">
      <v-card class="category-dialog-card">
        <v-card-title class="category-dialog-header">
          <div class="d-flex align-center justify-space-between w-100">
            <div class="d-flex align-center">
              <div class="category-header-icon-container">
                <v-avatar class="category-icon-background" size="46">
                  <v-icon color="#4b2667" size="24">mdi-shape</v-icon>
                </v-avatar>
              </div>
              <div>
                <div class="category-dialog-title">Category Management</div>
                <div class="category-dialog-subtitle">Manage the document tabs and their subcategories</div>
              </div>
            </div>
            <v-btn v-if="canAdd" variant="elevated" color="#1976D2" size="small" @click="openMetaDocCategoryDialog()">
              <v-icon start>mdi-plus</v-icon>
              Add Category
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text class="pa-6">
          <v-data-table :headers="metaDocCategoryHeaders" :items="metaDocCategories" :loading="loadingMetaDocCategories" density="comfortable" :items-per-page="12">
            <template v-slot:item.isActive="{ item }">
              <v-chip :color="item.isActive ? 'success' : 'error'" size="small" variant="outlined">
                {{ item.isActive ? 'Active' : 'Inactive' }}
              </v-chip>
            </template>
            <template v-slot:item.subCategoriesCount="{ item }">
              <v-chip color="info" size="small" variant="outlined">{{ item.subCategoriesCount || 0 }} Subcategories</v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <div class="action-buttons-group">
                <v-btn size="small" variant="outlined" color="secondary" class="action-btn" @click="viewMetaDocSubCategories(item)">
                  <v-icon size="16">mdi-view-list</v-icon>
                  <v-tooltip activator="parent" location="top">View Subcategories</v-tooltip>
                </v-btn>
                <v-btn size="small" variant="outlined" color="primary" class="action-btn" :disabled="!item.isManaged" @click="openMetaDocCategoryDialog(item)">
                  <v-icon size="16">{{ canEdit ? 'mdi-pencil' : 'mdi-eye-outline' }}</v-icon>
                  <v-tooltip activator="parent" location="top">{{ item.isManaged ? (canEdit ? 'Edit' : 'View') : 'View-only — managed via its subcategories' }}</v-tooltip>
                </v-btn>
                <v-btn v-if="canDelete" size="small" variant="outlined" color="error" class="action-btn" :disabled="!item.isManaged" @click="confirmDeleteMetaDocCategory(item)">
                  <v-icon size="16">mdi-delete</v-icon>
                  <v-tooltip activator="parent" location="top">{{ item.isManaged ? 'Deactivate' : 'View-only — managed via its subcategories' }}</v-tooltip>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn variant="outlined" @click="closeMetaDocCategoriesDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ════════ Meta Document Category Create/Edit Dialog ════════ -->
    <v-dialog v-model="metaDocCategoryDialog" max-width="600px">
      <v-card class="category-dialog-card">
        <v-card-title class="category-dialog-header">
          <div class="d-flex align-center">
            <div class="category-header-icon-container">
              <v-avatar class="category-icon-background" size="46">
                <v-icon color="#4b2667" size="24">{{ metaDocCategoryEditMode ? 'mdi-pencil' : 'mdi-plus' }}</v-icon>
              </v-avatar>
            </div>
            <div>
              <div class="category-dialog-title">{{ metaDocCategoryEditMode ? (canEdit ? 'Edit Category' : 'View Category') : 'Create Category' }}</div>
              <div class="category-dialog-subtitle">{{ metaDocCategoryEditMode ? 'Update this category' : 'Add a new top-level category' }}</div>
            </div>
          </div>
        </v-card-title>
        <v-card-text class="pa-6">
          <v-form ref="metaDocCategoryForm" v-model="metaDocCategoryFormValid">
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="metaDocCategoryFormData.title" label="Category*" variant="outlined" density="comfortable" hide-details="auto" :rules="[v => !!v || 'Required']"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="metaDocCategoryFormData.code" label="Code*" maxlength="10" variant="outlined" density="comfortable" hide-details="auto" :rules="[v => !!v || 'Required']"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model.number="metaDocCategoryFormData.displayOrder" label="Display Order" type="number" variant="outlined" density="comfortable" hide-details="auto"></v-text-field>
              </v-col>
              <v-col cols="12" class="d-flex align-center">
                <v-checkbox v-model="metaDocCategoryFormData.isActive" label="Active" color="primary" hide-details></v-checkbox>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn variant="elevated" color="#f0960a" class="text-white" @click="closeMetaDocCategoryDialog">Cancel</v-btn>
          <v-btn v-if="metaDocCategoryEditMode ? canEdit : canAdd" variant="elevated" color="#1976D2" :loading="savingMetaDocCategory" :disabled="!metaDocCategoryFormValid" @click="saveMetaDocCategory">
            {{ metaDocCategoryEditMode ? 'Update' : 'Create' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ════════ Meta Document Subcategories View Dialog ════════ -->
    <v-dialog v-model="metaDocSubCategoriesDialog" max-width="1000px">
      <v-card class="category-dialog-card">
        <v-card-title class="category-dialog-header">
          <div class="d-flex align-center justify-space-between w-100">
            <div class="d-flex align-center">
              <div class="category-header-icon-container">
                <v-avatar class="category-icon-background" size="46">
                  <v-icon color="#4b2667" size="24">mdi-view-list</v-icon>
                </v-avatar>
              </div>
              <div>
                <div class="category-dialog-title">Subcategories</div>
                <div class="category-dialog-subtitle">{{ selectedMetaDocCategory ? selectedMetaDocCategory.title : '' }}</div>
              </div>
            </div>
            <v-btn v-if="canAdd" variant="elevated" color="#1976D2" size="small" @click="openMetaDocSubCategoryDialog()">
              <v-icon start>mdi-plus</v-icon>
              Add Subcategory
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text class="pa-6">
          <v-data-table :headers="metaDocSubCategoryHeaders" :items="metaDocCategorySubCategories" :loading="loadingMetaDocSubCategories" density="comfortable">
            <template v-slot:item.isActive="{ item }">
              <v-chip :color="item.isActive ? 'success' : 'error'" size="small" variant="outlined">
                {{ item.isActive ? 'Active' : 'Inactive' }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <div class="action-buttons-group">
                <v-btn
                  v-if="shouldShowProductSubtypeAction(item)"
                  size="small"
                  variant="outlined"
                  color="secondary"
                  class="action-btn"
                  :aria-label="`Product Subtype for ${item.key}`"
                  @click="openMetaDocProductSubtypeDialog(item)"
                >
                  <v-icon size="16">mdi-format-list-bulleted</v-icon>
                  <v-tooltip activator="parent" location="top">Product Subtype</v-tooltip>
                </v-btn>
                <v-btn size="small" variant="outlined" color="primary" class="action-btn" @click="openMetaDocSubCategoryDialog(item)">
                  <v-icon size="16">{{ canEdit ? 'mdi-pencil' : 'mdi-eye-outline' }}</v-icon>
                  <v-tooltip activator="parent" location="top">{{ canEdit ? 'Edit' : 'View' }}</v-tooltip>
                </v-btn>
                <v-btn v-if="canDelete" size="small" variant="outlined" color="error" class="action-btn" @click="confirmDeleteMetaDocSubCategory(item)">
                  <v-icon size="16">mdi-delete</v-icon>
                  <v-tooltip activator="parent" location="top">Deactivate</v-tooltip>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn variant="outlined" @click="closeMetaDocSubCategoriesDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ════════ Insurance-only Product Subtype Management ════════ -->
    <v-dialog v-model="metaDocProductSubtypeDialog" max-width="900px">
      <v-card class="category-dialog-card">
        <v-card-title class="category-dialog-header">
          <div class="d-flex align-center justify-space-between w-100">
            <div class="d-flex align-center">
              <div class="category-header-icon-container">
                <v-avatar class="category-icon-background" size="46">
                  <v-icon color="#4b2667" size="24">mdi-format-list-bulleted</v-icon>
                </v-avatar>
              </div>
              <div>
                <div class="category-dialog-title">Product Subtype</div>
                <div class="category-dialog-subtitle">
                  {{ selectedMetaDocProductSubtypeCategory ? selectedMetaDocProductSubtypeCategory.key : 'Insurance' }}
                </div>
              </div>
            </div>
            <v-btn v-if="canAdd" variant="elevated" color="#1976D2" size="small" @click="openMetaDocProductSubtypeForm()">
              <v-icon start>mdi-plus</v-icon>
              Add Product Subtype
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text class="pa-6">
          <v-data-table
            :headers="metaDocProductSubtypeHeaders"
            :items="metaDocProductSubtypeRows"
            :loading="loadingMetaDocProductSubtypes"
            density="comfortable"
          >
            <template v-slot:item.isActive="{ item }">
              <v-chip :color="item.isActive ? 'success' : 'error'" size="small" variant="outlined">
                {{ item.isActive ? 'Active' : 'Inactive' }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <div class="action-buttons-group">
                <v-btn v-if="canEdit" size="small" variant="outlined" color="primary" class="action-btn" @click="openMetaDocProductSubtypeForm(item)">
                  <v-icon size="16">mdi-pencil</v-icon>
                  <v-tooltip activator="parent" location="top">Edit</v-tooltip>
                </v-btn>
                <v-btn v-if="canDelete" size="small" variant="outlined" color="error" class="action-btn" @click="confirmDeleteMetaDocProductSubtype(item)">
                  <v-icon size="16">mdi-delete</v-icon>
                  <v-tooltip activator="parent" location="top">Delete</v-tooltip>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn variant="outlined" @click="closeMetaDocProductSubtypeDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ════════ Product Subtype Create/Edit Dialog ════════ -->
    <v-dialog v-model="metaDocProductSubtypeFormDialog" max-width="520px">
      <v-card class="category-dialog-card">
        <v-card-title class="category-dialog-header">
          <div class="d-flex align-center">
            <div class="category-header-icon-container">
              <v-avatar class="category-icon-background" size="46">
                <v-icon color="#4b2667" size="24">{{ metaDocProductSubtypeFormData.id > 0 ? 'mdi-pencil' : 'mdi-plus' }}</v-icon>
              </v-avatar>
            </div>
            <div>
              <div class="category-dialog-title">{{ metaDocProductSubtypeFormData.id > 0 ? 'Edit Product Subtype' : 'Add Product Subtype' }}</div>
              <div class="category-dialog-subtitle">{{ selectedMetaDocProductSubtypeCategory ? selectedMetaDocProductSubtypeCategory.key : 'Insurance' }}</div>
            </div>
          </div>
        </v-card-title>
        <v-card-text class="pa-6">
          <v-form ref="metaDocProductSubtypeForm" v-model="metaDocProductSubtypeFormValid">
            <v-combobox
              v-model="metaDocProductSubtypeFormData.productType"
              :items="metaDocProductSubtypeTypeOptions"
              label="Product Type*"
              variant="outlined"
              density="comfortable"
              hide-details="auto"
              :rules="[v => !!v || 'Required']"
              class="mb-4"
            ></v-combobox>
            <v-text-field
              v-if="isNewMetaDocProductSubtypeType"
              v-model="metaDocProductSubtypeFormData.productTypeCode"
              label="Product Type Code*"
              maxlength="10"
              variant="outlined"
              density="comfortable"
              hide-details="auto"
              :rules="[v => !!v || 'Required']"
              class="mb-4"
            ></v-text-field>
            <v-text-field
              v-model="metaDocProductSubtypeFormData.productSubtype"
              label="Product Subtype*"
              variant="outlined"
              density="comfortable"
              hide-details="auto"
              :rules="[v => !!v || 'Required']"
              class="mb-4"
            ></v-text-field>
            <v-text-field
              v-model="metaDocProductSubtypeFormData.code"
              label="Code*"
              maxlength="10"
              variant="outlined"
              density="comfortable"
              hide-details="auto"
              :rules="[v => !!v || 'Required']"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn variant="outlined" @click="closeMetaDocProductSubtypeForm">Cancel</v-btn>
          <v-btn variant="elevated" color="#1976D2" :loading="savingMetaDocProductSubtype" :disabled="!metaDocProductSubtypeFormValid" @click="saveMetaDocProductSubtype">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ════════ Meta Document Subcategory Create/Edit Dialog ════════ -->
    <v-dialog v-model="metaDocSubCategoryDialog" max-width="500px">
      <v-card class="category-dialog-card">
        <v-card-title class="category-dialog-header">
          <div class="d-flex align-center">
            <div class="category-header-icon-container">
              <v-avatar class="category-icon-background" size="46">
                <v-icon color="#4b2667" size="24">{{ metaDocSubCategoryEditMode ? 'mdi-pencil' : 'mdi-plus' }}</v-icon>
              </v-avatar>
            </div>
            <div>
              <div class="category-dialog-title">{{ metaDocSubCategoryEditMode ? (canEdit ? 'Edit Subcategory' : 'View Subcategory') : 'Create Subcategory' }}</div>
              <div class="category-dialog-subtitle">{{ metaDocSubCategoryEditMode ? 'Update this subcategory' : 'Add a new subcategory' }}</div>
            </div>
          </div>
        </v-card-title>
        <v-card-text class="pa-6">
          <v-form ref="metaDocSubCategoryForm" v-model="metaDocSubCategoryFormValid">
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="metaDocSubCategoryFormData.key" label="Subcategory*" variant="outlined" density="comfortable" hide-details="auto" :rules="[v => !!v || 'Required']"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="metaDocSubCategoryFormData.code" label="Code*" maxlength="10" variant="outlined" density="comfortable" hide-details="auto" :rules="[v => !!v || 'Required']"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model.number="metaDocSubCategoryFormData.displayOrder" label="Display Order" type="number" variant="outlined" density="comfortable" hide-details="auto"></v-text-field>
              </v-col>
              <v-col cols="12" class="d-flex align-center">
                <v-checkbox v-model="metaDocSubCategoryFormData.isActive" label="Active" color="primary" hide-details></v-checkbox>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn variant="elevated" color="#f0960a" class="text-white" @click="closeMetaDocSubCategoryDialog">Cancel</v-btn>
          <v-btn v-if="metaDocSubCategoryEditMode ? canEdit : canAdd" variant="elevated" color="#1976D2" :loading="savingMetaDocSubCategory" :disabled="!metaDocSubCategoryFormValid" @click="saveMetaDocSubCategory">
            {{ metaDocSubCategoryEditMode ? 'Update' : 'Create' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <NewsApiConnectionDialog
      v-if="newsConnectionOpen"
      v-model="newsConnectionOpen"
      :permissions="{ add: canAdd, edit: canEdit, delete: canDelete }"
    />
    <!-- โหมด Center: Policy / แชร์ ของเอกสาร (dialog เดิมของ Kcc — คุยกับ Center ผ่าน kccApi เอง) -->
    <KccPolicyShareDialog
      v-if="centerMode"
      v-model="kccPolicyShareOpen"
      :document="kccPolicyDoc"
      @updated="ReFreshGet"
    />
  </div>
</template>
<script>
import NewsApiConnectionDialog from '@/components/NewsApiConnectionDialog.vue';
import KccPolicyShareDialog from '@/components/KnowledgeCenterClient/KccPolicyShareDialog.vue';
import { kccApi } from '@/services/kccApi';
import { createMetaDocSource } from '@/services/metaDocSource';
import { h } from 'vue';
import checkPermissionTwo from '@/api/function.js';
import dateUtils from '../plugins/date-utils';
import moment from 'moment';
import FilterIcon from '@/assets/images/mage_filter.svg';
import {
  buildMetaDocProductFormData,
  createProductImagePreviews,
  createProductDisplayFields,
  getProductSubtypeOptions,
  isNewProductType,
  shouldShowProductSubtypeAction as canShowProductSubtypeAction,
} from '@/utils/metaDocProductUi.js';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

const NonLoopTimePicker = {
  name: 'NonLoopTimePicker',
  props: {
    time: { type: Object, required: true },
    updateTime: { type: Function, required: true },
  },
  methods: {
    getPart(value) {
      const rawValue = Array.isArray(value) ? value[0] : value;
      const numberValue = Number(rawValue);
      return Number.isFinite(numberValue) ? numberValue : 0;
    },
    formatPart(value) {
      return String(this.getPart(value)).padStart(2, '0');
    },
    getOptions(isHours) {
      const max = isHours ? 23 : 59;
      return Array.from({ length: max + 1 }, (_, value) => value);
    },
    renderPart(label, value, isHours) {
      const current = this.getPart(value);
      return h('div', { class: 'non-loop-time-column', role: 'listbox', 'aria-label': label },
        this.getOptions(isHours).map((option) => h('button', {
          key: option,
          type: 'button',
          class: ['non-loop-time-option', { 'non-loop-time-option-active': option === current }],
          role: 'option',
          'aria-selected': option === current ? 'true' : 'false',
          onClick: () => this.updateTime(option, isHours),
        }, this.formatPart(option)))
      );
    },
  },
  render() {
    return h('div', { class: 'non-loop-time-picker' }, [
      this.renderPart('hours', this.time.hours, true),
      h('div', { class: 'non-loop-time-separator' }, ':'),
      this.renderPart('minutes', this.time.minutes, false),
    ]);
  },
};

export default {
  name: "MetaDoc",
  inject: [
    "flagNav",
    "FontColorTitle",
    "SubNavbarBackGround",
    "Username",
    "RoleId"
  ],
  mixins: [checkPermissionTwo],
  components: {
    NewsApiConnectionDialog,
    VueDatePicker,
    NonLoopTimePicker,
    KccPolicyShareDialog,
  },
  data: () => ({
    newsConnectionOpen: false,
    centerMode: false, // โหมด App Knowledge Center (kccApi.status().enabled) — false ⇒ หน้าเดิมทุกอย่าง
    kccStatus: null,
    // แหล่งข้อมูลของหน้า (services/metaDocSource.js) — โหมดปกติส่งต่อ $call เดิม · โหมด Center ยิง proxy ของ Genie
    kccSrc: null,
    kccSourceFilter: 'all', // โหมด Center: all | own | shared (client-side จาก scope ของแถว)
    kccReadOnly: false, // dialog Edit เปิดกับเอกสารที่ได้รับแชร์แบบดู (scope view) ⇒ อ่านอย่างเดียว
    kccPolicyShareOpen: false,
    kccPolicyDoc: null,
    knowledgeCategories: [
      { id: 'all', name: 'All Categories', value: null },
      { id: 'promotion', name: 'Promotion', value: 1 },
      { id: 'banking_service', name: 'Banking Service', value: 2 },
      { id: 'product_insurance', name: 'Product Insurance', value: 3 },
      { id: 'customer_support', name: 'Customer Support', value: 4 },
      { id: 'investment_advisory', name: 'Investment Advisory', value: 5 },
    ],
    searchDebounceTimer: null, // Timer for debouncing search input
    filterTimeout: null, // Timer for debouncing filter changes
    drawerIcon: FilterIcon,
    filterDrawer: false, // Filter drawer data

    productImageLanguages: [
      { key: 'th', label: 'TH' },
      { key: 'en', label: 'EN' },
      { key: 'cn', label: 'CN' },
    ],

    // Add New Item dialog
    dialogAddItem: false,
    newItem: {
      productCategory: '',
      productType: '',
      productSubtype: '',
      // ติ๊กได้หลายอัน — ตัวแรกในรายการคือ 'ตัวหลัก' ที่ backend เขียนลงคอลัมน์ SubTitle / ProductSubtype เดิม
      productTypes: [],
      productSubtypes: [],
      tsCategory: '',
      tsType: '',
      nameTH: '',
      nameEN: '',
      ...createProductDisplayFields(),
      keyword: '',
      prompt: '',
      taxYear: null,
    },
    newItemRules: {
      required: (v) => !!v || 'Required.',
    },

    // Troubleshooting dropdown options
    troubleshootingCategories: [
      'Application_issues', 'Transaction_issues', 'Service_issues', 'Deposit_issues',
      'Loan_issues', 'Insurance_issues', 'Card_issues', 'Promotion_issues',
      'Investment_issues', 'Fraud',
    ],
    troubleshootingTypes: [
      'Registration', 'Login', 'Identity_verification', 'Access', 'Setting',
      'Account_blocked', 'Notification', 'Transfer', 'Payment', 'Topup',
      'Deposit_money', 'Withdrawal', 'Schedule', 'Auto_direct_debit', 'FCD_transfer',
      'Open_deposit_account', 'Foreigners Open Account', 'FCD_open_account',
      'Apply_loan', 'Apply_insurance', 'Mutual_funds', 'Favorite',
      'QR_to_receive_money', 'Promptpay', 'Interest_certificate', 'Apply_for_eDividend',
      'Rewards', 'Portfolio_declare', 'Find_LHB_branch', 'Branch_foreigner',
      'Prompttrade', 'Foreigner_service_fee', 'Account_status', 'Loan_billing_issue',
      'Sweet_crush',
    ],

    // Edit Item dialog
    dialogEditItem: false,
    editItem: {
      vectorDBName: '',
      productCategory: '',
      productType: '',
      productSubtype: '',
      // ติ๊กได้หลายอัน — ตัวแรกในรายการคือ 'ตัวหลัก' ที่ backend เขียนลงคอลัมน์ SubTitle / ProductSubtype เดิม
      productTypes: [],
      productSubtypes: [],
      tsCategory: '',
      tsType: '',
      nameTH: '',
      nameEN: '',
      ...createProductDisplayFields(),
      keyword: '',
      prompt: '',
    },

    statusFilters: {
      all: true,
      active: false,
      inactive: false,
    },
    statusFilter: 'all',
    statusFilterOptions: [
      { title: 'All', value: 'all' },
      { title: 'Active', value: 'active' },
      { title: 'Inactive', value: 'inactive' },
    ],
    selectedCategory: null,
    effectiveStartDate: null,
    effectiveEndDate: null,

    // Title/SubTitle tab and chip state
    selectedTitle: 'Product',
    selectedSubTitle: 'All',
    titleOptions: [
      'Product', 'Tax', 'ServiceInfo', 'Financial_Transaction', 'Promotion',
      'Contact_Agent', 'Family_Banking', 'Troubleshooting', 'Greeting',
      'Non_Banking', 'Triage_Agent'
    ],
    titleOptionOrder: [
      'Product', 'Tax', 'ServiceInfo', 'Financial_Transaction', 'Promotion',
      'Contact_Agent', 'Family_Banking', 'Troubleshooting', 'Greeting',
      'Non_Banking', 'Triage_Agent'
    ],
    titleSubTitleMap: {
      'Product': ['Deposit', 'Loan', 'Insurance', 'Card'],
      'Tax': ['Personal_Income_Tax', 'Corporate_Tax'],
      'ServiceInfo': ['Service_Info', 'Page_Navigation', 'Branch_Navigation'],
      'Financial_Transaction': ['Transfer', 'TopUp', 'Paybill'],
      'Promotion': [], 'Contact_Agent': [], 'Family_Banking': [],
      'Troubleshooting': [], 'Greeting': [], 'Non_Banking': [], 'Triage_Agent': [],
    },
    productSubtypeMap: {
      'Deposit': ['Saving', 'Time_Deposit', 'Tax_Free'],
      'Loan': ['Home_Loan', 'Personal_Loan'],
      'Insurance': ['Life', 'Non-life'],
      'Card': ['Debit', 'Credit'],
      'Personal_Income_Tax': ['e-Filing', 'Withholding'],
      'Corporate_Tax': ['VAT', 'Half_Year_Filing'],
    },
    productSubSubtypeMap: {
      'Saving': ['THB', 'Foreign_Currency_Deposit'],
      'Time_Deposit': ['THB', 'Foreign_Currency_Deposit'],
      'Tax_Free': ['THB', 'Foreign_Currency_Deposit'],
      'Home_Loan': ['New/Default', 'Refinance', 'Home_for_Cash'],
      'Personal_Loan': ['New/Default'],
      'Life': ['Endowment', 'Others'],
      'Non-life': ['Fire_Insurance', 'Accident', 'Miscellaneous_Insurance', 'Motor_Insurance'],
      'Debit': ['New/Default'],
      'Credit': ['New/Default'],
    },
    metaDocPrefixMapping: null,

    // Add original data storage for frontend filtering
    originalDataTable: [], // Store original unfiltered data
    //........

    uploadDialog: false,
    checkbox1: false,
    EditdialogUser: false,
    AddVector: false,
    dialog: false,
    loadingTable: false,
    loading: true,
    loadingDownload: true,
    today: null,
    searchVectorDBName: null,
    searchVectorProcess: 0,
    searchVectorDBName2: null,
    requestVector: {
      modelType: null,
      modelId: null,
      vectordbName: null,
      entity: null,
      deleteAll: true,
    },
    options: {
      page: 1,
      itemsPerPage: -1,
      sortBy: [],
      sortDesc: [],
    },

    DDModel: [],
    files: [],
    dataTable: [],
    dataTable2: [],
    isSearch: false,
    isSearch2: false,
    isFirst: true,
    isFirst2: true,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,

    searchTotalTable2: 0,
    totalTable2: 0,
    itemsPerPage2: 10,
    showTable: false,
    rules: {
      required: (value) => !!value || 'Required.',
    },
    sortBy: [],
    sortDesc: [],

    // ── Meta Document Category / SubCategory management ──
    // Categories == MetaDocPrefixMapping rows where Level = "Category"
    // SubCategories == MetaDocPrefixMapping rows where Level = "Type"
    metaDocCategoriesDialog: false,
    metaDocCategoryDialog: false,
    metaDocSubCategoriesDialog: false,
    metaDocSubCategoryDialog: false,
    metaDocCategoryEditMode: false,
    metaDocSubCategoryEditMode: false,
    loadingMetaDocCategories: false,
    loadingMetaDocSubCategories: false,
    savingMetaDocCategory: false,
    savingMetaDocSubCategory: false,
    metaDocCategoryFormValid: false,
    metaDocSubCategoryFormValid: false,
    metaDocCategories: [],
    metaDocCategorySubCategories: [],
    selectedMetaDocCategory: null,
    metaDocProductSubtypeDialog: false,
    metaDocProductSubtypeFormDialog: false,
    metaDocProductSubtypeFormValid: false,
    loadingMetaDocProductSubtypes: false,
    savingMetaDocProductSubtype: false,
    selectedMetaDocProductSubtypeCategory: null,
    metaDocProductSubtypeRows: [],
    metaDocProductSubtypeFormData: {
      id: 0,
      productType: '',
      productTypeCode: '',
      productSubtype: '',
      code: '',
      displayOrder: 0,
      isActive: true,
    },
    metaDocCategoryFormData: {
      id: 0,
      title: '',
      code: '',
      displayOrder: 0,
      isActive: true,
    },
    metaDocSubCategoryFormData: {
      id: 0,
      categoryTitle: '',
      key: '',
      code: '',
      displayOrder: 0,
      isActive: true,
    },
    metaDocCategoryHeaders: [
      { title: 'Category', key: 'title' },
      { title: 'Code', key: 'code' },
      { title: 'Order', key: 'displayOrder' },
      { title: 'Subcategories', key: 'subCategoriesCount' },
      { title: 'Status', key: 'isActive' },
      { title: 'Actions', key: 'actions', sortable: false },
    ],
    metaDocSubCategoryHeaders: [
      { title: 'Subcategory', key: 'key' },
      { title: 'Code', key: 'code' },
      { title: 'Order', key: 'displayOrder' },
      { title: 'Status', key: 'isActive' },
      { title: 'Actions', key: 'actions', sortable: false },
    ],
    metaDocProductSubtypeHeaders: [
      { title: 'Product Type', key: 'productType' },
      { title: 'Product Subtype', key: 'productSubtype' },
      { title: 'Code', key: 'code' },
      { title: 'Status', key: 'isActive' },
      { title: 'Actions', key: 'actions', sortable: false },
    ],

  }),
  computed: {
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('MetaDoc');
    },
    bindingTitles() {
      return ['ServiceInfo', 'Financial_Transaction'];
    },
    simpleFormTitles() {
      return ['Promotion', 'Family_Banking', 'Contact_Agent', 'Greeting', 'Non_Banking', 'Triage_Agent', '__OTHERS__'];
    },
    selectedTitleLabel() {
      if (this.selectedTitle === '__OTHERS__') return 'Others';
      return this.selectedTitle ? this.selectedTitle.replace(/_/g, ' ') : 'Product';
    },
    showDetailHeader() {
      return this.simpleFormTitles.includes(this.selectedTitle) || this.bindingTitles.includes(this.selectedTitle) || this.selectedTitle === 'Troubleshooting';
    },
    showProductFields() {
      return this.selectedTitle === 'Product' || this.selectedTitle === 'ServiceInfo' || this.selectedTitle === 'Tax';
    },
    showFinancialTransactionFields() {
      return this.selectedTitle === 'Financial_Transaction';
    },
    showFullProductFields() {
      return this.selectedTitle === 'Product';
    },
    showProductTypeField() {
      return this.selectedTitle === 'Product' || this.selectedTitle === 'Tax';
    },
    // #746 ปีภาษี พ.ศ. ล้วน (เช่น 2569) ปีปัจจุบัน ±1 — ตรงกับ TaxYearV2.BeYear ที่ taxPlanningV2 ใช้กรอง
    // ถ้าปีที่บันทึกไว้อยู่นอกช่วง (API ตั้งได้ทุกปี) ใส่เพิ่มให้ยังเห็นค่าเดิม
    editItemTaxYearOptions() {
      return this.taxYearOptionsFor(this.editItem.taxYear);
    },
    newItemTaxYearOptions() {
      return this.taxYearOptionsFor(this.newItem.taxYear);
    },
    canAdd() {
      return !!(this.$pagePermission && this.$pagePermission.canAdd('MetaDoc'));
    },
    canEdit() {
      return !!(this.$pagePermission && this.$pagePermission.canEdit('MetaDoc'));
    },
    canDelete() {
      return !!(this.$pagePermission && this.$pagePermission.canDelete('MetaDoc'));
    },
    permissions() {
      return {
        add: this.$pagePermission && this.$pagePermission.canAdd('MetaDoc'),
        edit: this.$pagePermission && this.$pagePermission.canEdit('MetaDoc'),
        delete: this.$pagePermission && this.$pagePermission.canDelete('MetaDoc'),
      }
    },
    // ── โหมด App Knowledge Center ──
    /** เปิดโหมด Center แต่ยังไม่มี Admin key ⇒ ไม่ยิง Center (แสดง alert ไปหน้าตั้งค่าแทนแท็บ/ตาราง) */
    kccNotReady() {
      return this.centerMode && !(this.kccStatus && this.kccStatus.adminReady);
    },
    /** ตั้ง Policy / แชร์ ได้เฉพาะ role 0/1 (ท่าเดียวกับ Kcc เดิม) */
    kccIsAdmin() {
      return ['0', '1'].includes(String(this.RoleId));
    },
    /** ตัวนับของปุ่ม ทั้งหมด/ของเรา/ได้รับแชร์ — นับจากแถวของแท็บ/ชิปปัจจุบัน หลังกรองสถานะ (ก่อนกรองแหล่ง) */
    kccSourceCounts() {
      const rows = (this.originalDataTable || []).filter((item) => {
        const active = item.activeStatus === true || item.activeStatus === 'true' || item.activeStatus === 1;
        if (this.statusFilter === 'active') return active;
        if (this.statusFilter === 'inactive') return !active;
        return true;
      });
      const own = rows.filter((item) => this.kccSourceOf(item) === 'own').length;
      return { all: rows.length, own, shared: rows.length - own };
    },
    headers() {
      // โหมด Center: ปุ่มต่อแถวเพิ่ม Policy ⇒ คอลัมน์ Actions กว้างขึ้น + คอลัมน์ เจ้าของ/สิทธิ์ ต่อจาก Item ID (ตรงกับ <td> ใน slot item)
      const kccColumns = this.centerMode
        ? [
          { title: this.$t('kccOwner'), align: 'left', sortable: false, width: '170px' },
          { title: this.$t('kccPermission'), align: 'center', sortable: false, width: '160px' },
        ]
        : [];
      return [
        { title: 'Actions', align: 'center', sortable: false, width: this.centerMode ? '260px' : '220px', class: 'sticky-action' },
        { title: 'Item ID', align: 'center', sortable: false, width: '120px' },
        ...kccColumns,
        { title: 'Status', align: 'center', sortable: false, width: '100px' },
        { title: 'Process', align: 'center', sortable: false, width: '120px' },
        { title: 'Product Category', value: 'title', align: 'left', sortable: true, width: '160px' },
        { title: 'Product Type', value: 'subTitle', align: 'left', sortable: true, width: '160px' },
        { title: 'Product Subtype', value: 'productSubtype', align: 'left', sortable: true, width: '170px' },
        { title: 'Name EN', align: 'left', sortable: false, width: '180px' },
        { title: 'Name TH', align: 'left', sortable: false, width: '180px' },
        { title: 'Keyword', align: 'left', sortable: false, width: '150px' },
        { title: 'Prompt', align: 'left', sortable: false, width: '200px' },
        { title: 'Last Update', value: 'last_update', align: 'left', sortable: true, width: '140px' },
      ];
    },

    availableSubTitles() {
      if (this.selectedTitle === '__OTHERS__') return [];
      return this.titleSubTitleMap[this.selectedTitle] || [];
    },
    titleTabs() {
      return [...this.titleOptions, 'Others'];
    },
    newItemProductCategories() {
      return this.titleSubTitleMap[this.selectedTitle] || [];
    },
    newItemProductTypes() {
      return this.productSubtypeMap[this.newItem.productCategory] || [];
    },
    editItemProductCategories() {
      return this.titleSubTitleMap[this.selectedTitle] || [];
    },
    financialTransactionTypes() {
      return this.selectedTitle === 'Financial_Transaction' ? (this.titleSubTitleMap[this.selectedTitle] || []) : [];
    },
    editItemProductTypes() {
      return this.productSubtypeMap[this.editItem.productCategory] || [];
    },
    // ติ๊กหลาย type ⇒ subtype ที่เลือกได้คือ union ของทุก type ที่ติ๊กไว้
    newItemProductSubtypes() {
      const types = Array.isArray(this.newItem.productTypes) ? this.newItem.productTypes : [];
      const options = types.flatMap((productType) => getProductSubtypeOptions(
        this.newItem.productCategory,
        productType,
        this.productSubSubtypeMap,
        this.metaDocProductSubtypeRows,
      ));
      return [...new Set(options.filter(Boolean))];
    },
    // ติ๊กหลาย type ⇒ subtype ที่เลือกได้คือ union ของทุก type ที่ติ๊กไว้
    editItemProductSubtypes() {
      const types = Array.isArray(this.editItem.productTypes) ? this.editItem.productTypes : [];
      const options = types.flatMap((productType) => getProductSubtypeOptions(
        this.editItem.productCategory,
        productType,
        this.productSubSubtypeMap,
        this.metaDocProductSubtypeRows,
      ));
      return [...new Set(options.filter(Boolean))];
    },
    metaDocProductSubtypeTypeOptions() {
      const categoryKey = this.selectedMetaDocProductSubtypeCategory?.key;
      return this.productSubtypeMap[categoryKey] || [];
    },
    isNewMetaDocProductSubtypeType() {
      return isNewProductType(
        this.metaDocProductSubtypeFormData.productType,
        this.metaDocProductSubtypeTypeOptions,
      );
    },

    filteredDataTable() {
      let filtered = [...this.originalDataTable];

      if (this.searchVectorDBName && this.searchVectorDBName.trim()) {
        const searchTerm = this.searchVectorDBName.toLowerCase().trim();
        filtered = filtered.filter((item) => {
          const fields = [item.vectorDBName, item.nameEN, item.nameTH, item.keyword];
          return fields.some((f) => f && f.toLowerCase().includes(searchTerm));
        });
      }

      // Apply status filter
      if (this.statusFilter === 'active') {
        filtered = filtered.filter((item) => {
          return item.activeStatus === true || item.activeStatus === 'true' || item.activeStatus === 1;
        });
      } else if (this.statusFilter === 'inactive') {
        filtered = filtered.filter((item) => {
          return item.activeStatus === false || item.activeStatus === 'false' || item.activeStatus === 0 || item.activeStatus === null || item.activeStatus === undefined;
        });
      }
      // If 'all' is selected, don't apply status filter

      // โหมด Center: ของเรา / ได้รับแชร์ (A8 — client-side จาก scope ของแถว)
      if (this.centerMode && (this.kccSourceFilter === 'own' || this.kccSourceFilter === 'shared')) {
        filtered = filtered.filter((item) => this.kccSourceOf(item) === this.kccSourceFilter);
      }

      // Apply knowledge category filter
      if (this.selectedCategory !== null && this.selectedCategory !== undefined) {
        filtered = filtered.filter((item) => item.knowledgeCategory === this.selectedCategory);
      }

      // Apply date filter with OR logic
      if (this.effectiveStartDate || this.effectiveEndDate) {
        filtered = filtered.filter((item) => {
          let matchesDateFilter = false;

          // Check start date condition: item start date >= filter start date
          if (this.effectiveStartDate && item.effectiveStartDate) {
            const itemStartDate = new Date(item.effectiveStartDate);
            const filterStartDate = new Date(this.effectiveStartDate);
            if (itemStartDate >= filterStartDate) {
              matchesDateFilter = true;
            }
          }

          // Check end date condition: item end date <= filter end date
          if (this.effectiveEndDate && item.effectiveEndDate) {
            const itemEndDate = new Date(item.effectiveEndDate);
            const filterEndDate = new Date(this.effectiveEndDate);
            if (itemEndDate <= filterEndDate) {
              matchesDateFilter = true;
            }
          }

          // If only one filter is set, check that condition
          if (this.effectiveStartDate && !this.effectiveEndDate && item.effectiveStartDate) {
            const itemStartDate = new Date(item.effectiveStartDate);
            const filterStartDate = new Date(this.effectiveStartDate);
            matchesDateFilter = itemStartDate >= filterStartDate;
          }

          if (this.effectiveEndDate && !this.effectiveStartDate && item.effectiveEndDate) {
            const itemEndDate = new Date(item.effectiveEndDate);
            const filterEndDate = new Date(this.effectiveEndDate);
            matchesDateFilter = itemEndDate <= filterEndDate;
          }

          return matchesDateFilter;
        });
      }

      const startNumber = ((this.options.page || 1) - 1) * (this.options.itemsPerPage || 10) + 1;
      filtered = filtered.map((item, index) => ({
        ...item,
        number: startNumber + index,
      }));

      console.log('Filtered Data:', filtered);
      return filtered;
    },
  },
  watch: {
    options: {
      handler() {
        if (this._initialized) this.Get();
      },
      deep: true,
    },

    selectedTitle: {
      handler() {
        this.selectedSubTitle = 'All';
        if (!this.dialogAddItem) {
          this.newItem.productCategory = '';
          this.newItem.productType = '';
          this.newItem.productSubtype = '';
          this.resetProductDisplayFields('newItem');
          this.newItem.tsCategory = '';
          this.newItem.tsType = '';
        }
        if (!this.dialogEditItem) {
          this.editItem.productCategory = '';
          this.editItem.productType = '';
          this.editItem.productSubtype = '';
          this.resetProductDisplayFields('editItem');
          this.editItem.tsCategory = '';
          this.editItem.tsType = '';
        }
        if (this._initialized) {
          this.options.page = 1;
          this.Get();
        }
      },
    },
    selectedSubTitle: {
      handler() {
        if (this._initialized) {
          this.options.page = 1;
          this.Get();
        }
      },
    },
    searchVectorDBName: {
      handler(newValue) {
        // No need to call API, filteredDataTable computed property will handle it
        this.Get(newValue);
        //console.log('Search changed:', newValue);
      },
    },

    // Filter watchers to bind with table data
    'statusFilters.all': {
      handler(newValue) {
        if (newValue) {
          this.statusFilters.active = false;
          this.statusFilters.inactive = false;
        }
        // console.log('Status filter changed - All:', newValue);
        // No API call needed, computed property handles filtering
      },
    },

    'statusFilters.active': {
      handler(newValue) {
        if (newValue) {
          this.statusFilters.all = false;
          this.statusFilters.inactive = false;
        }
        //console.log('Status filter changed - Active:', newValue);
        // No API call needed, computed property handles filtering
      },
    },

    'statusFilters.inactive': {
      handler(newValue) {
        if (newValue) {
          this.statusFilters.all = false;
          this.statusFilters.active = false;
        }
        //console.log('Status filter changed - Inactive:', newValue);
        // No API call needed, computed property handles filtering
      },
    },

    selectedCategory: {
      handler(newCategory) {
        //console.log('Knowledge Category changed:', newCategory);
        // No API call needed, computed property handles filtering
      },
    },

    effectiveStartDate: {
      handler(newStartDate) {
        //console.log('Effective Start Date changed:', newStartDate);
        // With OR logic, date range validation is more flexible
        // Users can set either or both dates for filtering
      },
    },

    effectiveEndDate: {
      handler(newEndDate) {
        //console.log('Effective End Date changed:', newEndDate);
        // With OR logic, date range validation is more flexible
        // Users can set either or both dates for filtering
      },
    },
  },
  methods: {
    onProductLanguageImagesSelected(itemKey, languageKey, files) {
      const item = this[itemKey];
      const selectedFiles = Array.from(files || []);
      const invalidFile = selectedFiles.find((file) => file.type && !file.type.startsWith('image/'));

      if (invalidFile) {
        console.error(`Product ${languageKey.toUpperCase()} image selection rejected: expected image files.`, invalidFile.type);
        return;
      }

      item.imageFiles[languageKey] = selectedFiles;
      item.imagePreviews[languageKey] = selectedFiles.map((file) => ({ name: file.name, src: '', existing: false }));

      if (!selectedFiles.length) return;
      if (typeof FileReader === 'undefined') {
        console.error('Product image preview unavailable: FileReader is not supported in this browser.');
        return;
      }

      selectedFiles.forEach((file, index) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          item.imagePreviews[languageKey][index].src = event.target?.result || '';
        };
        reader.onerror = () => {
          console.error(`Product ${languageKey.toUpperCase()} image preview failed to read the selected file.`, reader.error);
          item.imagePreviews[languageKey][index].src = '';
        };
        reader.readAsDataURL(file);
      });
    },
    onProductLanguageImagesDropped(itemKey, languageKey, event) {
      this.onProductLanguageImagesSelected(itemKey, languageKey, event?.dataTransfer?.files || []);
    },
    removeProductLanguageImage(itemKey, languageKey, index) {
      const item = this[itemKey];
      item.imageFiles[languageKey].splice(index, 1);
      item.imagePreviews[languageKey].splice(index, 1);
    },
    resetProductDisplayFields(itemKey) {
      Object.assign(this[itemKey], createProductDisplayFields());
    },
    closeAddItemDialog() {
      this.dialogAddItem = false;
      this.resetProductDisplayFields('newItem');
    },
    closeEditItemDialog() {
      this.dialogEditItem = false;
      this.resetProductDisplayFields('editItem');
    },
    onEffectiveStartChange(newVal) {
      if (!newVal) { this.effectiveStartDate = null; return; }
      const newD = new Date(newVal);
      const oldD = this.effectiveStartDate ? new Date(this.effectiveStartDate) : null;
      if (!oldD || newD.toDateString() !== oldD.toDateString()) {
        newD.setHours(0, 0, 0, 0);
      }
      this.effectiveStartDate = newD;
    },
    onEffectiveEndChange(newVal) {
      if (!newVal) { this.effectiveEndDate = null; return; }
      const newD = new Date(newVal);
      const oldD = this.effectiveEndDate ? new Date(this.effectiveEndDate) : null;
      if (!oldD || newD.toDateString() !== oldD.toDateString()) {
        newD.setHours(0, 0, 0, 0);
      }
      this.effectiveEndDate = newD;
    },
    applyMetaDocPrefixMapping(mapping) {
      if (!mapping) return;

      const items = Array.isArray(mapping.items) ? mapping.items : [];
      const sortedItems = [...items].sort((a, b) => {
        const orderDiff = (a.displayOrder || 0) - (b.displayOrder || 0);
        if (orderDiff !== 0) return orderDiff;
        return (a.key || '').localeCompare(b.key || '');
      });

      const topLevelItems = sortedItems.filter((item) => ['Category', 'Tab'].includes(item.level));
      const titleOptions = topLevelItems
        .map((item) => item.documentCategory || item.key)
        .filter((value, index, array) => value && array.indexOf(value) === index);

      const orderedTitleOptions = [
        ...this.titleOptionOrder.filter((value) => titleOptions.includes(value)),
        ...titleOptions.filter((value) => !this.titleOptionOrder.includes(value)),
      ];

      const categoryIdToTitle = new Map();
      const typeIdToKey = new Map();

      topLevelItems.forEach((item) => {
        if (item.level === 'Category') {
          categoryIdToTitle.set(item.id, item.documentCategory || item.key);
        }
      });

      const titleSubTitleMap = {};
      orderedTitleOptions.forEach((title) => {
        titleSubTitleMap[title] = [];
      });

      topLevelItems
        .filter((item) => item.level === 'Category')
        .forEach((item) => {
          const title = item.documentCategory || item.key;
          if (!titleSubTitleMap[title]) {
            titleSubTitleMap[title] = [];
          }
          if (!titleSubTitleMap[title].includes(item.key)) {
            titleSubTitleMap[title].push(item.key);
          }
        });

      sortedItems
        .filter((item) => item.level === 'Binding' && item.documentCategory)
        .forEach((item) => {
          const title = item.documentCategory;
          if (!titleSubTitleMap[title]) {
            titleSubTitleMap[title] = [];
          }
          if (!titleSubTitleMap[title].includes(item.key)) {
            titleSubTitleMap[title].push(item.key);
          }
        });

      const productSubtypeMap = {};
      sortedItems.filter((item) => item.level === 'Type').forEach((item) => {
        const parentTitle = categoryIdToTitle.get(item.parentID) || 'Product';
        const productCategory = items.find((candidate) => candidate.id === item.parentID)?.key;
        if (productCategory) {
          if (!productSubtypeMap[productCategory]) {
            productSubtypeMap[productCategory] = [];
          }
          productSubtypeMap[productCategory].push(item.key);
        }
        typeIdToKey.set(item.id, item.key);

        if (!titleSubTitleMap[parentTitle]) {
          titleSubTitleMap[parentTitle] = [];
        }
      });

      const productSubSubtypeMap = {};
      sortedItems.filter((item) => item.level === 'Subtype').forEach((item) => {
        const parentType = typeIdToKey.get(item.parentID);
        if (!parentType) return;
        if (!productSubSubtypeMap[parentType]) {
          productSubSubtypeMap[parentType] = [];
        }
        productSubSubtypeMap[parentType].push(item.key);
      });

      this.metaDocPrefixMapping = mapping;
      this.titleOptions = orderedTitleOptions;
      this.titleSubTitleMap = titleSubTitleMap;
      this.productSubtypeMap = productSubtypeMap;
      this.productSubSubtypeMap = productSubSubtypeMap;

      if (!this.titleOptions.includes(this.selectedTitle)) {
        this.selectedTitle = this.titleOptions[0] || 'Product';
      }

      const availableSubTitles = this.titleSubTitleMap[this.selectedTitle] || [];
      if (this.selectedSubTitle !== 'All' && !availableSubTitles.includes(this.selectedSubTitle)) {
        this.selectedSubTitle = 'All';
      }
    },
    loadMetaDocPrefixMapping() {
      return new Promise((resolve) => {
        this.kccSrc.GetMetaDocPrefixMapping(
          (dataResponse) => {
            if (dataResponse.status === 0 && dataResponse.data) {
              this.applyMetaDocPrefixMapping(dataResponse.data);
            }
            resolve();
          },
          (errorResource) => {
            console.error('GetMetaDocPrefixMapping error:', errorResource);
            resolve();
          }
        );
      });
    },
    // Clear all filters - frontend only
    clearFilters() {
      this.statusFilters = {
        all: true,
        active: false,
        inactive: false,
      };
      this.statusFilter = 'all';
      this.selectedCategory = null;
      this.effectiveStartDate = null;
      this.effectiveEndDate = null;
      this.searchVectorDBName = null;
      this.selectedTitle = this.titleOptions[0];
      this.selectedSubTitle = 'All';
    },

    toggleActive(item, isActive) {
      let self = this;

      // Immediately update UI for better user experience
      const previousStatus = item.activeStatus;
      item.activeStatus = isActive;

      // Also update in original data table immediately
      const originalItem = self.originalDataTable.find((orig) => orig.vectorDBName === item.vectorDBName);
      if (originalItem) {
        originalItem.activeStatus = isActive;
      }

      // Show loading state
      self.dialog = true;

      // Prepare API request data
      var parameter = {
        vectorDBName: item.vectorDBName,
        activeStatus: isActive,
      };

      // Call API to update active status
      self.$call.UpdateActiveStatus(
        parameter,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            // Show success message
            self.$swal.fire({
              icon: 'success',
              title: 'Status Updated',
              text: `Document ${isActive ? 'activated' : 'deactivated'} successfully`,
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            // Revert the changes on API error
            item.activeStatus = previousStatus;
            if (originalItem) {
              originalItem.activeStatus = previousStatus;
            }

            self.$swal.fire({
              icon: 'error',
              title: 'Update Failed',
              text: dataResponse.message || 'Failed to update status',
              timer: 2000,
            });
          }
          self.dialog = false;
        },
        (errorResource) => {
          // Revert the changes on error
          item.activeStatus = previousStatus;
          if (originalItem) {
            originalItem.activeStatus = previousStatus;
          }

          self.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to update status. Please try again.',
            timer: 2000,
          });

          self.dialog = false;
          console.error('UpdateActiveStatus error:', errorResource);
        }
      );
    },
    formatText(text) {
      // ๝ปลงช่องว่างเป็น &nbsp; เพื่อให้รัฝษาช่องว่างได้
      return text.replace(/ /g, '&nbsp;');
    },
    toggleFilterDrawer() {
      this.filterDrawer = !this.filterDrawer;
    },
    Get() {
      let self = this;
      // โหมด Center ที่ยังไม่มี Admin key ⇒ ไม่ยิง (watcher ของแท็บ/ค้นหาก็ผ่านทางนี้) — โหมดปกติไม่มีผล
      if (self.kccNotReady) return;
      // self.dialog = true;
      self.loadingTable = true;

      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }

      // For Product tab: items are stored with Title = product category (Deposit/Loan/etc.)
      // For other tabs: items are stored with Title = tab name, SubTitle = chip value
      const isProductTab = self.selectedTitle === 'Product' || self.selectedTitle === 'Tax';
      let apiTitle = null;
      let apiSubTitle = null;
      let apiTitles = null;
      if (isProductTab) {
        if (self.selectedSubTitle !== 'All') {
          apiTitle = self.selectedSubTitle;
        } else {
          // "All" chip on Product tab: send all product categories as titles array
          apiTitles = self.titleSubTitleMap[self.selectedTitle] || [];
        }
      } else {
        apiTitle = self.selectedTitle || null;
        apiSubTitle = self.selectedSubTitle === 'All' ? null : self.selectedSubTitle;
      }

      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : 999999,
        name: self.searchVectorDBName && self.searchVectorDBName.trim() ? self.searchVectorDBName : null,
        sortDesc: sortOrder,
        sortBy: sortField,
        title: apiTitle,
        subTitle: apiSubTitle,
        titles: apiTitles,
      };

      //console.log('API call without filters:', temp);

      self.kccSrc.GetMetaDocList(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            // Store original data for filtering
            self.originalDataTable = dataResponse.data.data.map((item, index) => ({
              ...item,
              number: index + 1,
            }));
            self.dataTable = [...self.originalDataTable]; // Keep for compatibility
            self.totalTable = self.isFirst ? dataResponse.data.total : self.totalTable;
            if (!self.isFirst) {
              self.AutoRefresh();
            }
          } else {
            self.originalDataTable = [];
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.loadingTable = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.loadingTable = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetDefault() {
      let self = this;
      self.dialog = true;
      self.loading = true;
      let { itemsPerPage } = self.options;

      const isProductTab = self.selectedTitle === 'Product' || self.selectedTitle === 'Tax';
      let apiTitle = null;
      let apiSubTitle = null;
      let apiTitles = null;
      if (isProductTab) {
        if (self.selectedSubTitle !== 'All') {
          apiTitle = self.selectedSubTitle;
        } else {
          apiTitles = self.titleSubTitleMap[self.selectedTitle] || [];
        }
      } else {
        apiTitle = self.selectedTitle || null;
        apiSubTitle = self.selectedSubTitle === 'All' ? null : self.selectedSubTitle;
      }

      let temp = {
        page: 1,
        perPage: itemsPerPage != -1 ? itemsPerPage : 999999,
        name: self.searchVectorDBName,
        sortDesc: null,
        sortBy: null,
        title: apiTitle,
        subTitle: apiSubTitle,
        titles: apiTitles,
      };
      self.kccSrc.GetMetaDocList(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst ? dataResponse.data.total : self.totalTable;
            if (!self.isFirst) {
              //console.log(self.isFirst);
              self.AutoRefresh();
            }
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    ReFreshGet() {
      let self = this;
      self.loading = true;
      let { page, itemsPerPage } = this.options;

      const isProductTab = self.selectedTitle === 'Product' || self.selectedTitle === 'Tax';
      let apiTitle = null;
      let apiSubTitle = null;
      let apiTitles = null;
      if (isProductTab) {
        if (self.selectedSubTitle !== 'All') {
          apiTitle = self.selectedSubTitle;
        } else {
          apiTitles = self.titleSubTitleMap[self.selectedTitle] || [];
        }
      } else {
        apiTitle = self.selectedTitle || null;
        apiSubTitle = self.selectedSubTitle === 'All' ? null : self.selectedSubTitle;
      }

      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : 999999,
        name: self.searchVectorDBName,
        title: apiTitle,
        subTitle: apiSubTitle,
        titles: apiTitles,
      };
      self.kccSrc.GetMetaDocList(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst ? dataResponse.data.total : self.totalTable;
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    Search() {
      // Search is now handled by computed property filteredDataTable
      // No API call needed, just trigger reactivity
      //console.log('Search triggered for:', this.searchVectorDBName);
    },
    Save() {
      let self = this;
      if (!self.requestVector.modelType || !self.searchVectorDBName2 || !self.requestVector.entity) {
        alert('Please Fill All The Fields!');
        return;
      }
      self.requestVector.vectordbName = self.searchVectorDBName2;
      self.dialog = true;
      try {
        self.$call.UploadCSV2Vector(
          self.requestVector,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: 'success',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              self.Clear();
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.AddVector = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    back(e) {
      if (e) {
        this.EditdialogUser = false;
        this.AddVector = false;
      }
    },
    Reprocess(source) {
      let self = this;
      self.$swal
        .fire({
          icon: 'warning',
          title: this.$t('vectorReprocess'),
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('cancel'),
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.dialog = true;
            try {
              let data = {
                vectordbName: source.vectorDBName,
              };
              self.$call.ReProcessedVector(
                data,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    source.isError = false;
                    self.Get();
                    self.$swal.fire({
                      icon: 'success',
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  console.error(errorResource.message);
                }
              );
            } catch (error) {
              self.LogTrace(error, 'ReProcess');
            }
          }
        });
    },
    processUpload(e) {
      this.files = e;
      if (this.files.length == 0) {
        this.requestVector.entity = null;
        return;
      }
      const reader = new FileReader();
      reader.readAsText(this.files[0]);
      reader.onload = () => {
        let text = reader.result;
        this.ValidateCSVVector(text, this.files);
      };
    },
    ValidateCSVVector(csv, files) {
      let temp = csv.replaceAll('\r', '');
      let lines = temp.split('\n');
      if (lines[0] != 'text_org,text_en') {
        this.requestVector.entity = null;
        alert('Please Enter Correct Format!');
      } else {
        const formDataDoc = new FormData();
        formDataDoc.append('entity', files[0]);
        this.requestVector.entity = formDataDoc;
      }
    },
    UpdatePersonalInformation(item) {
      let self = this;
      self.dialog = true;
      var parameter = {
        VectorDBName: item.vectorDBName,
      };
      self.$call.UpdatePersonalInformation(
        parameter,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.$swal.fire({
              icon: 'success',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 1500,
            });
            self.Get();
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    DeleteByName(name) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t('confirmDeletion'),
            text: this.$t('confirmDeletionDocumentName'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#e67e22',
            cancelButtonColor: '#7f8c8d',
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.kccSrc.DeleteVectorDBNameByName(
                name,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: 'success',
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    self.Get();
                  }else if (dataResponse.status == 1) {
                    self.$swal.fire({
                      icon: "error",
                      title: dataResponse.message,
                      showConfirmButton: true,
                      confirmButtonText: this.$t("gotIt"),
                      confirmButtonColor: "#d33",
                    });
                  } else {
                    // status อื่น (เช่น 6 ไม่พบ หรือซอง 403/404 จาก Center) — เดิมเงียบ ⇒ แสดงข้อความเหมือนกิ่ง status 1
                    self.$swal.fire({
                      icon: "error",
                      title: (dataResponse && dataResponse.message) || 'Failed to delete item',
                      showConfirmButton: true,
                      confirmButtonText: this.$t("gotIt"),
                      confirmButtonColor: "#d33",
                    });
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  self.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    // ตัวแรกในรายการที่ติ๊ก = ตัวหลักที่ไปลงคอลัมน์เดี่ยวเดิม
    primaryOf(list) {
      return (Array.isArray(list) ? list : [])[0] || '';
    },
    // tag ที่โชว์ในคอลัมน์ Product Type ของตาราง
    // ใช้ productTypeNames จาก backend ก่อน ถ้าไม่มีก็ถอยไปสตริงเดี่ยว
    productTypeTags(item) {
      const names = Array.isArray(item?.productTypeNames) ? item.productTypeNames.filter(Boolean) : [];
      const source = names.length ? names : (item?.subTitle ? [item.subTitle] : []);
      return source.map((name) => String(name).replace(/_/g, ' '));
    },
    // tag ที่โชว์ในคอลัมน์ Product Subtype ของตาราง
    // ใช้ productSubtypeNames จาก backend ก่อน ถ้าไม่มีก็ถอยไปสตริงเดี่ยวเดิม
    // (backend เติม fallback ให้อยู่แล้วที่ FillProductNames แต่กันไว้เผื่อ response เก่า)
    productSubtypeTags(item) {
      const names = Array.isArray(item?.productSubtypeNames) ? item.productSubtypeNames.filter(Boolean) : [];
      const source = names.length ? names : (item?.productSubtype ? [item.productSubtype] : []);
      return source.map((name) => String(name).replace(/_/g, ' '));
    },
    onNewItemCategoryChange() {
      this.newItem.productType = '';
      this.newItem.productSubtype = '';
      this.newItem.productTypes = [];
      this.newItem.productSubtypes = [];
    },
    // ตัดเฉพาะ subtype ที่ไม่ได้อยู่ใต้ type ที่ยังติ๊กอยู่
    // (ต่างจากเดิมที่ล้างทิ้งหมด เพราะตอนนี้ติ๊กได้หลายอัน ล้างหมดจะน่ารำคาญ)
    onNewItemTypeChange() {
      const allowed = this.newItemProductSubtypes;
      this.newItem.productSubtypes = (this.newItem.productSubtypes || [])
        .filter((name) => allowed.includes(name));
      this.newItem.productSubtype = '';
    },
    onEditItemCategoryChange() {
      this.editItem.productType = '';
      this.editItem.productSubtype = '';
      this.editItem.productTypes = [];
      this.editItem.productSubtypes = [];
    },
    // ตัดเฉพาะ subtype ที่ไม่ได้อยู่ใต้ type ที่ยังติ๊กอยู่
    // (ต่างจากเดิมที่ล้างทิ้งหมด เพราะตอนนี้ติ๊กได้หลายอัน ล้างหมดจะน่ารำคาญ)
    onEditItemTypeChange() {
      const allowed = this.editItemProductSubtypes;
      this.editItem.productSubtypes = (this.editItem.productSubtypes || [])
        .filter((name) => allowed.includes(name));
      this.editItem.productSubtype = '';
    },
    validateNewItemProductType(value) {
      if (!this.showProductTypeField || this.newItemProductTypes.length === 0) {
        return true;
      }
      return (Array.isArray(value) && value.length > 0) || 'Required';
    },
    validateNewItemProductSubtype(value) {
      if (this.newItemProductSubtypes.length === 0) {
        return true;
      }
      return (Array.isArray(value) && value.length > 0) || 'Required';
    },
    validateEditItemProductType(value) {
      if (!this.showProductTypeField || this.editItemProductTypes.length === 0) {
        return true;
      }
      return (Array.isArray(value) && value.length > 0) || 'Required';
    },
    validateEditItemProductSubtype(value) {
      if (this.editItemProductSubtypes.length === 0) {
        return true;
      }
      return (Array.isArray(value) && value.length > 0) || 'Required';
    },
    // #746 ตัวเลือกปีภาษี พ.ศ. (เช่น 2569) ปีปัจจุบัน ±1 — ตรงกับ TaxYearV2.BeYear ที่ taxPlanningV2 ใช้กรอง
    // ถ้าปีที่บันทึกไว้อยู่นอกช่วง (API ตั้งได้ทุกปี) ใส่เพิ่มให้ยังเห็นค่าเดิม
    taxYearOptionsFor(saved) {
      const current = new Date().getFullYear() + 543;
      const years = [current - 1, current, current + 1];
      if (saved != null && !years.includes(saved)) years.push(saved);
      return years.sort((a, b) => a - b);
    },
    Add() {
      const isBindingTab = this.bindingTitles.includes(this.selectedTitle);
      const isFinancialTransaction = this.selectedTitle === 'Financial_Transaction';
      const isProductTab = this.selectedTitle === 'Product' || this.selectedTitle === 'Tax';
      const hasSelectedSubTitle = this.selectedSubTitle && this.selectedSubTitle !== 'All';
      this.newItem = {
        productCategory: ((isBindingTab || isProductTab) && hasSelectedSubTitle) ? this.selectedSubTitle : '',
        productType: (isFinancialTransaction && hasSelectedSubTitle) ? this.selectedSubTitle : '',
        productSubtype: '',
        productTypes: [],
        productSubtypes: [],
        tsCategory: '',
        tsType: '',
        nameTH: '',
        nameEN: '',
        ...createProductDisplayFields(),
        keyword: '',
        prompt: '',
        taxYear: null,
      };
      this.dialogAddItem = true;
      this.$nextTick(() => this.$refs.addItemForm?.resetValidation());
    },
    async SaveNewItem() {
      const isSimpleForm = this.simpleFormTitles.includes(this.selectedTitle);
      const isBindingTab = this.bindingTitles.includes(this.selectedTitle);
      const isFinancialTransaction = this.selectedTitle === 'Financial_Transaction';
      const isTroubleshooting = this.selectedTitle === 'Troubleshooting';

      const { valid } = await this.$refs.addItemForm.validate();
      if (!valid) {
        return;
      }

      // Apply binding tab defaults AFTER validation passes to avoid wiping user input
      if (isBindingTab) {
        if (isFinancialTransaction) {
          this.newItem.productType = this.newItem.productType || (this.selectedSubTitle !== 'All' ? this.selectedSubTitle : '');
        } else {
          this.newItem.productCategory = this.newItem.productCategory || (this.selectedSubTitle !== 'All' ? this.selectedSubTitle : '');
        }
      }

      let title = this.selectedTitle;
      if (isSimpleForm || isBindingTab || isTroubleshooting) {
        title = this.selectedTitle;
      } else if (this.newItem.productCategory) {
        title = this.newItem.productCategory;
      }

      let self = this;
      self.dialog = true;
      self.dialogAddItem = false;

      var request = {
        title: title,
        // subTitle / productSubtype = ตัวหลัก · backend จะเขียนทับด้วยตัวแรกของ array ให้อีกที
        subTitle: isBindingTab ? ((isFinancialTransaction ? self.newItem.productType : self.newItem.productCategory) || null) : (isSimpleForm || isTroubleshooting ? null : (self.primaryOf(self.newItem.productTypes) || self.newItem.productType || null)),
        productSubtype: isSimpleForm || isBindingTab || isTroubleshooting ? null : (self.primaryOf(self.newItem.productSubtypes) || null),
        // ชุดเต็มที่ติ๊กมา — ของใหม่
        productTypeNames: isSimpleForm || isBindingTab || isTroubleshooting ? [] : (self.newItem.productTypes || []),
        productSubtypeNames: isSimpleForm || isBindingTab || isTroubleshooting ? [] : (self.newItem.productSubtypes || []),
        nameTH: self.newItem.nameTH,
        nameEN: self.newItem.nameEN,
        keyword: self.newItem.keyword || null,
        prompt: self.newItem.prompt || null,
        tsCategory: isTroubleshooting ? self.newItem.tsCategory : null,
        tsType: isTroubleshooting ? self.newItem.tsType : null,
        vectordbName: null,
        itemID: null,
      };
      request.nameCN = self.newItem.nameCN || null;
      request.isTaxPlanning = Boolean(self.newItem.isTaxPlanning);
      request.keyHighlightTH = self.newItem.keyHighlights.th || null;
      request.keyHighlightEN = self.newItem.keyHighlights.en || null;
      request.keyHighlightCN = self.newItem.keyHighlights.cn || null;
      request.linkToBuy = self.newItem.linkToBuy || null;
      // #746 ปีภาษีเฉพาะแท็บ Tax · ว่าง (null) ไม่ถูก append ลง FormData = เอกสารไม่ระบุปี
      if (self.selectedTitle === 'Tax') request.taxYear = self.newItem.taxYear ?? null;
      const formData = buildMetaDocProductFormData(request, self.newItem.imageFiles);

      self.kccSrc.CreateMetaDocItem(
        formData,
        (dataResponse) => {
          self.dialog = false;
          if (dataResponse.status == 0 && dataResponse.data) {
            self.$swal.fire({
              icon: 'success',
              title: 'Item Created',
              text: `Item ID: ${dataResponse.data.itemID}`,
              showConfirmButton: false,
              timer: 1500,
            });
            self.$router.push({
              name: 'DocumentControl',
              query: {
                name: dataResponse.data.vectorDBName || null,
                productCategory: title,
                subTitle: isBindingTab ? ((isFinancialTransaction ? self.newItem.productType : self.newItem.productCategory) || null) : (self.newItem.productType || null),
                productSubtype: isSimpleForm || isBindingTab || isTroubleshooting ? null : (self.newItem.productSubtype || null),
                itemID: dataResponse.data.itemID,
                nameEN: self.newItem.nameEN || null,
                nameTH: self.newItem.nameTH || null,
                // A12: ธงโหมด Center ให้ DocumentControl (เอกสารที่เพิ่งสร้าง = ของเรา) · โหมดปกติไม่ใส่
                center: self.centerMode ? '1' : undefined,
                scope: self.centerMode ? 'owner' : undefined,
              },
            });
          } else {
            self.$swal.fire({
              icon: 'error',
              title: 'Error',
              text: dataResponse.message || 'Failed to create item',
              timer: 2000,
            });
          }
        },
        (errorResource) => {
          self.dialog = false;
          if (self.kccPopupShown(errorResource)) return;
          self.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to create item. Please try again.',
            timer: 2000,
          });
          console.error('CreateMetaDocItem error:', errorResource);
        }
      );
    },
    Edit(item) {
      const isBindingTab = this.bindingTitles.includes(this.selectedTitle);
      const isFinancialTransaction = this.selectedTitle === 'Financial_Transaction';
      // D19: โหมด Center + ได้รับแชร์แบบดู ⇒ dialog อ่านอย่างเดียว (โหมดปกติ = false เสมอ)
      this.kccReadOnly = this.centerMode && this.kccScopeOf(item) === 'view';
      this.editItem = {
        vectorDBName: item.vectorDBName || '',
        productCategory: isBindingTab && !isFinancialTransaction ? (item.subTitle || '') : (item.title || ''),
        // productType เดี่ยว ใช้เฉพาะแท็บ Financial_Transaction (Binding) ที่ยังเลือกได้อันเดียว
        productType: isBindingTab ? (isFinancialTransaction ? (item.subTitle || '') : '') : (item.subTitle || ''),
        productSubtype: isBindingTab ? '' : (item.productSubtype || ''),
        // แท็บสินค้าใช้ array — backend กาง ProductTypeIds เป็นชื่อมาให้แล้วใน productTypeNames
        // ถ้าเอกสารยังไม่เคย backfill จะถอยไปใช้สตริงเดี่ยวให้เอง (ดู FillProductNames ฝั่ง BAL)
        productTypes: isBindingTab ? [] : (Array.isArray(item.productTypeNames) && item.productTypeNames.length
          ? [...item.productTypeNames]
          : (item.subTitle ? [item.subTitle] : [])),
        productSubtypes: isBindingTab ? [] : (Array.isArray(item.productSubtypeNames) && item.productSubtypeNames.length
          ? [...item.productSubtypeNames]
          : (item.productSubtype ? [item.productSubtype] : [])),
        tsCategory: item.tsCategory || '',
        tsType: item.tsType || '',
        nameTH: item.nameTH || '',
        nameEN: item.nameEN || '',
        ...createProductDisplayFields(),
        imagePreviews: {
          th: createProductImagePreviews(item.imageTHUrl, 'th'),
          en: createProductImagePreviews(item.imageENUrl, 'en'),
          cn: createProductImagePreviews(item.imageCNUrl, 'cn'),
        },
        nameCN: item.nameCN || '',
        isTaxPlanning: Boolean(item.isTaxPlanning),
        taxYear: item.taxYear ?? null,
        keyHighlights: { th: item.keyHighlightTH || '', en: item.keyHighlightEN || '', cn: item.keyHighlightCN || '' },
        linkToBuy: item.linkToBuy || '',
        keyword: item.keyword || '',
        prompt: item.prompt || '',
      };
      this.dialogEditItem = true;
      this.$nextTick(() => this.$refs.editItemForm?.resetValidation());
    },
    ManageKnowledge(item) {
      this.$router.push({
        name: 'DocumentControl',
        query: {
          name: item.vectorDBName,
          productCategory: item.title || null,
          subTitle: item.subTitle || null,
          productSubtype: item.productSubtype || null,
          itemID: item.itemID || null,
          fromSubTab: this.selectedSubTitle || null,
          nameEN: item.nameEN || null,
          nameTH: item.nameTH || null,
          // A12/D19: ธงโหมด Center + สิทธิ์ของเราต่อเอกสาร (view ⇒ DocumentControl อ่านอย่างเดียว) · โหมดปกติไม่ใส่
          center: this.centerMode ? '1' : undefined,
          scope: this.centerMode ? this.kccScopeOf(item) : undefined,
        },
      });
    },
    async SaveEditItem() {
      if (this.kccReadOnly) return; // กันพลาด — ปุ่ม Save ซ่อนอยู่แล้วเมื่ออ่านอย่างเดียว
      const isSimpleForm = this.simpleFormTitles.includes(this.selectedTitle);
      const isBindingTab = this.bindingTitles.includes(this.selectedTitle);
      const isFinancialTransaction = this.selectedTitle === 'Financial_Transaction';
      const isTroubleshooting = this.selectedTitle === 'Troubleshooting';

      const { valid } = await this.$refs.editItemForm.validate();
      if (!valid) {
        return;
      }

      let self = this;
      self.dialog = true;
      self.dialogEditItem = false;

      var request = {
        vectorDBName: self.editItem.vectorDBName,
        title: isSimpleForm || isBindingTab || isTroubleshooting ? self.selectedTitle : self.editItem.productCategory,
        // subTitle / productSubtype = ตัวหลัก · backend จะเขียนทับด้วยตัวแรกของ array ให้อีกที
        subTitle: isBindingTab ? ((isFinancialTransaction ? self.editItem.productType : self.editItem.productCategory) || null) : (isSimpleForm || isTroubleshooting ? null : (self.primaryOf(self.editItem.productTypes) || self.editItem.productType || null)),
        productSubtype: isSimpleForm || isBindingTab || isTroubleshooting ? null : (self.primaryOf(self.editItem.productSubtypes) || null),
        // ชุดเต็มที่ติ๊กมา — ของใหม่
        productTypeNames: isSimpleForm || isBindingTab || isTroubleshooting ? [] : (self.editItem.productTypes || []),
        productSubtypeNames: isSimpleForm || isBindingTab || isTroubleshooting ? [] : (self.editItem.productSubtypes || []),
        nameTH: self.editItem.nameTH,
        nameEN: self.editItem.nameEN,
        keyword: self.editItem.keyword || null,
        prompt: self.editItem.prompt || null,
        tsCategory: isTroubleshooting ? self.editItem.tsCategory : null,
        tsType: isTroubleshooting ? self.editItem.tsType : null,
      };
      request.nameCN = self.editItem.nameCN || null;
      // #783 checkbox Tax Planning มีแค่แท็บ Product · แท็บอื่นไม่ส่ง (null ไม่ถูก append) = backend ไม่แตะค่าเดิม
      request.isTaxPlanning = self.showFullProductFields ? Boolean(self.editItem.isTaxPlanning) : null;
      request.keyHighlightTH = self.editItem.keyHighlights.th || null;
      request.keyHighlightEN = self.editItem.keyHighlights.en || null;
      request.keyHighlightCN = self.editItem.keyHighlights.cn || null;
      request.linkToBuy = self.editItem.linkToBuy || null;
      // #746 แท็บ Tax เท่านั้นที่ส่ง setTaxYear — taxYear ว่าง (null) ไม่ถูก append ลง FormData
      // backend จึงได้ null แล้วล้างปีทิ้ง · แท็บอื่นไม่ส่งอะไร = ไม่แตะปีเดิม
      if (self.selectedTitle === 'Tax') {
        request.setTaxYear = true;
        request.taxYear = self.editItem.taxYear ?? null;
      }
      const formData = buildMetaDocProductFormData(request, self.editItem.imageFiles);

      self.kccSrc.UpdateMetaDocItem(
        formData,
        (dataResponse) => {
          self.dialog = false;
          if (dataResponse.status == 0) {
            self.$swal.fire({
              icon: 'success',
              title: 'Item Updated',
              showConfirmButton: false,
              timer: 1500,
            });
            self.Get();
          } else {
            self.$swal.fire({
              icon: 'error',
              title: 'Error',
              text: dataResponse.message || 'Failed to update item',
              timer: 2000,
            });
          }
        },
        (errorResource) => {
          self.dialog = false;
          if (self.kccPopupShown(errorResource)) return;
          self.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to update item. Please try again.',
            timer: 2000,
          });
          console.error('UpdateMetaDocItem error:', errorResource);
        }
      );
    },

    DownloadCSV(item) {
      let self = this;
      self.dialog = true;
      // self.$call.GetVectorCSVExport(
      self.$call.GetVectorExcelExport(
        item.vectorDBName,
        (dataResponse) => {
          if (dataResponse) {
            let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;
            let fileName = `${item.vectorDBName}_${self.convertDateToString(new Date(), '')}.xlsx`;
            fileLink.setAttribute('download', fileName);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },

    convertDateToString(date, seperator = '/') {
      return dateUtils.getStringWithTimeFromDate(moment(date).toDate(), seperator);
    },

    Clear() {
      let self = this;

      self.EditdialogUser = false;
      self.AddVector = false;
      self.showTable = false;

      self.requestVector.entity = null;
      self.requestVector.modelId = null;
      self.requestVector.modelType = null;
      self.requestVector.vectordbName = null;

      self.searchVectorDBName = null;
      self.searchVectorDBName2 = null;
      self.dataTable = [];
      self.originalDataTable = []; // Clear original data too
      self.dataTable2 = [];
      self.searchTotalTable = 0;
      self.totalTable = 0;
      self.searchTotalTable2 = 0;
      self.totalTable2 = 0;
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }

      this.today = dd + '/' + mm + '/' + yyyy;
    },
    download() {
      const data = [];
      data.push('text_org,text_en\n');
      data.push('ชื่อบทความ (วรรณคดี): พระอภัยมณี,\n');
      data.push('Article Title (Literature): Phra Abhayamani,\n');
      data.push('Article Title (Literature): Phra Abhayamani (พระอภัยมณี),');

      const a = document.createElement('a');
      let blob = new Blob(data, { type: 'data:text/csv;charset=utf-8' });
      const url = window.URL.createObjectURL(blob);

      a.href = url;
      a.download = 'upload_vector.csv';
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    },
    async AutoRefresh() {
      let self = this;
      let death_waiting = true;
      do {
        death_waiting = false;
        for (let value of self.dataTable) {
          if (value.processingStatus === 'Processing') {
            self.ReFreshGet();
            death_waiting = true;
            break;
          }
        }
        if (window.location.pathname != '/metadoc') {
          death_waiting = false;
        }
        await new Promise((resolve) => setTimeout(resolve, 5000));
      } while (death_waiting);
    },


    handleKeypress(evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      const validCharactersRegex = /^[a-zA-Z0-9\u0E00-\u0E7F]+$/;

      if (!validCharactersRegex.test(String.fromCharCode(charCode))) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    processingChipColor(status) {
      if (status === 'Completed') return 'success';
      if (status === 'Processing') return 'warning';
      return 'grey';
    },
    processingChipIcon(status) {
      if (status === 'Completed') return 'mdi-check-circle';
      if (status === 'Processing') return 'mdi-clock-outline';
      return 'mdi-minus-circle-outline';
    },
    formatDate(date) {
      if (!date) return null;
      // Format date to YYYY-MM-DD format
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    formatEffectiveDate(dateString) {
      if (!dateString) return null;

      try {
        // Convert UTC datetime back to local timezone for display
        // This ensures you see the time you originally saved (e.g., 7:30 PM)
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '-';

        // Display in local timezone
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${day}/${month}/${year} ${hours}:${minutes}`;
      } catch (error) {
        console.error('Error formatting effective date:', error);
        return '-';
      }
    },
    formatEffectiveTime(dateString) {
      if (!dateString) return null;

      try {
        // Convert UTC datetime back to local timezone for display
        // This ensures you see the time you originally saved (e.g., 19:30:00)
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '-';

        // Display in local timezone with 24-hour format
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
      } catch (error) {
        console.error('Error formatting effective time:', error);
        return '-';
      }
    },
    getKnowledgeCategoryText(category) {
      if (category === null || category === undefined) return null;

      const categoryItem = this.knowledgeCategories.find((item) => item.value === category);
      return categoryItem ? categoryItem.name : category.toString();
    },
    btnDisableDelete(item) {
      // D14: เอกสารที่สร้างผ่าน Center บันทึก createBy = actor "genie-admin:<username>" ⇒ ตัด prefix ก่อนเทียบ (โหมดปกติเทียบตรงเหมือนเดิม)
      const createdBy = this.centerMode ? String(item.createBy || '').replace(/^genie-(admin|news):/, '') : item.createBy;
      if ((this.RoleId == 2 || this.RoleId == 6) && createdBy != this.Username) {
        return true;
      }
      return false;
    },

    // ── โหมด App Knowledge Center: สิทธิ์ต่อแถวจาก scope ที่ Center ส่งมา (owner | edit | view) ──
    /** scope ของเราต่อเอกสาร · ไม่มีค่า ⇒ owner (Center ส่งทุกแถว; server บังคับสิทธิ์ซ้ำอยู่แล้ว) */
    kccScopeOf(item) {
      const scope = String((item && item.scope) || '').trim().toLowerCase();
      return scope === 'edit' || scope === 'view' ? scope : 'owner';
    },
    /** own = เอกสารของเรา · shared = ได้รับแชร์ (edit/view) */
    kccSourceOf(item) {
      return this.kccScopeOf(item) === 'owner' ? 'own' : 'shared';
    },
    kccScopeLabel(item) {
      const scope = this.kccScopeOf(item);
      if (scope === 'owner') return this.$t('kccScopeOwner');
      if (scope === 'edit') return this.$t('kccScopeEdit');
      return this.$t('kccScopeView');
    },
    kccScopeColor(item) {
      const scope = this.kccScopeOf(item);
      if (scope === 'owner') return 'primary';
      if (scope === 'edit') return 'info';
      return 'secondary';
    },
    kccScopeIcon(item) {
      const scope = this.kccScopeOf(item);
      if (scope === 'owner') return 'mdi-crown-outline';
      if (scope === 'edit') return 'mdi-pencil-outline';
      return 'mdi-eye-outline';
    },
    kccOwnerName(item) {
      if (!item) return '-';
      const name = String(item.ownerCompanyName || '').trim();
      if (name) return name;
      return item.ownerCompanyId != null ? `#${item.ownerCompanyId}` : '-';
    },
    /** ปุ่ม Edit เป็น "แก้" หรือ "ดู" — โหมดปกติ = canEdit เดิม · โหมด Center scope view ⇒ ดูอย่างเดียว (D19) */
    kccCanEditRow(item) {
      return this.canEdit && !(this.centerMode && this.kccScopeOf(item) === 'view');
    },
    /** ปุ่ม Delete — โหมด Center เฉพาะเอกสารของเรา (scope owner) · โหมดปกติไม่มีผล */
    kccCanDeleteRow(item) {
      return !this.centerMode || this.kccScopeOf(item) === 'owner';
    },
    /** ปุ่ม Policy / แชร์ — โหมด Center + เอกสารของเรา + role 0/1 + สิทธิ์แก้ของหน้า */
    kccCanManageAccess(item) {
      return this.centerMode && this.kccIsAdmin && this.canEdit && this.kccScopeOf(item) === 'owner';
    },
    openKccPolicyShare(item) {
      if (!this.kccCanManageAccess(item)) return;
      // รูปที่ KccPolicyShareDialog อ่าน (ชื่อช่องแบบ Center: vectordbName / nameTh / nameEn) — dialog โหลด detail สดเองตอนเปิด
      this.kccPolicyDoc = {
        vectordbName: item.vectorDBName,
        scope: this.kccScopeOf(item),
        nameTh: item.nameTH || '',
        nameEn: item.nameEN || '',
        title: item.title || null,
        subTitle: item.subTitle || null,
        activeStatus: item.activeStatus === true || item.activeStatus === 'true' || item.activeStatus === 1,
        ownerCompanyId: item.ownerCompanyId,
        ownerCompanyName: item.ownerCompanyName,
      };
      this.kccPolicyShareOpen = true;
    },
    /** error ที่ kccSrc (โหมด Center) แสดง popup ไปแล้ว ⇒ หน้าไม่ต้องเด้งซ้ำ · error ของ $call เดิมคืน false เสมอ */
    kccPopupShown(err) {
      return !!(err && err.isMetaDocSource);
    },

    shouldShowProductSubtypeAction(item) {
      return canShowProductSubtypeAction(item);
    },
    openMetaDocProductSubtypeDialog(item) {
      if (!this.shouldShowProductSubtypeAction(item)) return;

      this.selectedMetaDocProductSubtypeCategory = item;
      this.metaDocProductSubtypeRows = [];
      this.metaDocProductSubtypeDialog = true;
      this.loadMetaDocProductSubtypes(item.key);
    },
    loadMetaDocProductSubtypes(productCategory) {
      if (!productCategory) return;

      this.loadingMetaDocProductSubtypes = true;
      this.kccSrc.GetMetaDocProductSubtypesByCategory(
        productCategory,
        (res) => {
          this.loadingMetaDocProductSubtypes = false;
          if (res && res.status === 0 && Array.isArray(res.data)) {
            this.metaDocProductSubtypeRows = res.data.map((row) => ({
              id: row.id,
              productCategory: row.productCategory,
              productType: row.productType,
              productSubtype: row.productSubtype,
              code: row.code,
              displayOrder: row.displayOrder || 0,
              isActive: row.isActive !== false,
            }));
            return;
          }

          this.metaDocProductSubtypeRows = [];
          this.$swal.fire({
            icon: 'error',
            title: 'Unable to load product subtypes',
            text: res?.message || 'The server returned an unsuccessful response.',
          });
        },
        (error) => {
          this.loadingMetaDocProductSubtypes = false;
          this.metaDocProductSubtypeRows = [];
          console.error('GetMetaDocProductSubtypesByCategory failed', error);
          if (this.kccPopupShown(error)) return;
          this.$swal.fire({
            icon: 'error',
            title: 'Unable to load product subtypes',
            text: 'Please try again or contact an administrator.',
          });
        }
      );
    },
    closeMetaDocProductSubtypeDialog() {
      this.metaDocProductSubtypeDialog = false;
      this.closeMetaDocProductSubtypeForm();
      this.selectedMetaDocProductSubtypeCategory = null;
      this.metaDocProductSubtypeRows = [];
      this.loadingMetaDocProductSubtypes = false;
    },
    openMetaDocProductSubtypeForm(row = null) {
      if (row) {
        this.metaDocProductSubtypeFormData = { ...row, productTypeCode: '' };
      } else {
        this.metaDocProductSubtypeFormData = {
          id: 0,
          productType: this.metaDocProductSubtypeTypeOptions[0] || '',
          productTypeCode: '',
          productSubtype: '',
          code: '',
          displayOrder: 0,
          isActive: true,
        };
      }
      this.metaDocProductSubtypeFormDialog = true;
      this.$nextTick(() => this.$refs.metaDocProductSubtypeForm?.resetValidation());
    },
    closeMetaDocProductSubtypeForm() {
      this.metaDocProductSubtypeFormDialog = false;
      if (this.$refs.metaDocProductSubtypeForm) this.$refs.metaDocProductSubtypeForm.resetValidation();
    },
    saveMetaDocProductSubtype() {
      if (!this.metaDocProductSubtypeFormValid) return;

      const payload = {
        id: this.metaDocProductSubtypeFormData.id || 0,
        productCategory: this.selectedMetaDocProductSubtypeCategory?.key || '',
        productType: this.metaDocProductSubtypeFormData.productType,
        productTypeCode: this.isNewMetaDocProductSubtypeType
          ? this.metaDocProductSubtypeFormData.productTypeCode
          : '',
        productSubtype: this.metaDocProductSubtypeFormData.productSubtype,
        code: this.metaDocProductSubtypeFormData.code,
        displayOrder: Number(this.metaDocProductSubtypeFormData.displayOrder) || 0,
        isActive: this.metaDocProductSubtypeFormData.isActive !== false,
      };

      const isEdit = payload.id > 0;
      this.savingMetaDocProductSubtype = true;
      const done = (res) => {
        this.savingMetaDocProductSubtype = false;
        if (res && res.status === 0) {
          this.$swal.fire({
            icon: 'success',
            title: isEdit ? 'Product subtype updated' : 'Product subtype created',
            showConfirmButton: false,
            timer: 1500,
          });
          this.closeMetaDocProductSubtypeForm();
          this.loadMetaDocProductSubtypes(payload.productCategory);
          this.loadMetaDocPrefixMapping();
          return;
        }

        this.$swal.fire({
          icon: 'error',
          title: isEdit ? 'Unable to update product subtype' : 'Unable to create product subtype',
          text: res?.message || 'The server returned an unsuccessful response.',
        });
      };
      const fail = (error) => {
        this.savingMetaDocProductSubtype = false;
        console.error('SaveMetaDocProductSubtype failed', error);
        if (this.kccPopupShown(error)) return;
        this.$swal.fire({
          icon: 'error',
          title: isEdit ? 'Unable to update product subtype' : 'Unable to create product subtype',
          text: 'Please try again or contact an administrator.',
        });
      };

      if (isEdit) {
        this.kccSrc.UpdateMetaDocProductSubtype(payload.id, payload, done, fail);
      } else {
        this.kccSrc.CreateMetaDocProductSubtype(payload, done, fail);
      }
    },
    async confirmDeleteMetaDocProductSubtype(row) {
      if (!row) return;

      const confirmed = await this.$swal.fire({
        title: 'Remove product subtype?',
        text: row.productSubtype,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Remove',
      });
      if (confirmed.isConfirmed) {
        this.kccSrc.DeleteMetaDocProductSubtype(
          row.id,
          (res) => {
            if (res && res.status === 0) {
              this.$swal.fire({
                icon: 'success',
                title: 'Product subtype removed',
                showConfirmButton: false,
                timer: 1500,
              });
              this.loadMetaDocProductSubtypes(this.selectedMetaDocProductSubtypeCategory?.key);
              this.loadMetaDocPrefixMapping();
              return;
            }

            this.$swal.fire({
              icon: 'error',
              title: 'Unable to remove product subtype',
              text: res?.message || 'The server returned an unsuccessful response.',
            });
          },
          (error) => {
            console.error('DeleteMetaDocProductSubtype failed', error);
            if (this.kccPopupShown(error)) return;
            this.$swal.fire({
              icon: 'error',
              title: 'Unable to remove product subtype',
              text: 'Please try again or contact an administrator.',
            });
          }
        );
      }
    },

    // ── Meta Document Category management dialogs ──
    openMetaDocCategoriesDialog() {
      this.metaDocCategoriesDialog = true;
      this.loadMetaDocCategories();
    },
    closeMetaDocCategoriesDialog() {
      this.metaDocCategoriesDialog = false;
    },
    loadMetaDocCategories() {
      var self = this;
      self.loadingMetaDocCategories = true;
      self.kccSrc.GetMetaDocCategories(
        function (res) {
          self.metaDocCategories = (res && res.status === 0 && res.data) ? res.data : [];
          self.loadingMetaDocCategories = false;
        },
        function () {
          self.metaDocCategories = [];
          self.loadingMetaDocCategories = false;
        }
      );
    },
    openMetaDocCategoryDialog(item) {
      this.metaDocCategoryEditMode = !!item;
      if (item) {
        this.metaDocCategoryFormData = Object.assign({}, item);
      } else {
        this.metaDocCategoryFormData = {
          id: 0,
          title: '',
          code: '',
          displayOrder: 0,
          isActive: true,
        };
      }
      this.metaDocCategoryDialog = true;
    },
    closeMetaDocCategoryDialog() {
      this.metaDocCategoryDialog = false;
      if (this.$refs.metaDocCategoryForm) this.$refs.metaDocCategoryForm.resetValidation();
    },
    saveMetaDocCategory() {
      var self = this;
      if (!self.metaDocCategoryFormValid) return;
      self.savingMetaDocCategory = true;
      var done = function (res) {
        self.savingMetaDocCategory = false;
        if (res && res.status === 0) {
          self.$swal.fire({ icon: 'success', title: self.metaDocCategoryEditMode ? 'Category updated' : 'Category created', showConfirmButton: false, timer: 1500 });
          self.closeMetaDocCategoryDialog();
          self.loadMetaDocCategories();
          self.loadMetaDocPrefixMapping();
        } else {
          self.$swal.fire({ icon: 'error', title: 'Error', text: (res && res.message) || 'Failed to save category', timer: 2000 });
        }
      };
      var fail = function (err) {
        self.savingMetaDocCategory = false;
        if (self.kccPopupShown(err)) return;
        self.$swal.fire({ icon: 'error', title: 'Error', text: (err && err.response && err.response.data && err.response.data.message) || 'Failed to save category', timer: 2000 });
      };
      if (self.metaDocCategoryEditMode) {
        self.kccSrc.UpdateMetaDocCategory(self.metaDocCategoryFormData.id, self.metaDocCategoryFormData, done, fail);
      } else {
        self.kccSrc.CreateMetaDocCategory(self.metaDocCategoryFormData, done, fail);
      }
    },
    async confirmDeleteMetaDocCategory(item) {
      var self = this;
      var confirmed = await self.$swal.fire({
        title: 'Are you sure?',
        text: 'Deactivate category: ' + item.title + '? This requires removing/deactivating its subcategories first.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, deactivate it!',
      });
      if (confirmed.isConfirmed) {
        self.kccSrc.DeleteMetaDocCategory(
          item.id,
          function (res) {
            if (res && res.status === 0) {
              self.$swal.fire({ icon: 'success', title: 'Category deactivated', showConfirmButton: false, timer: 1500 });
              self.loadMetaDocCategories();
              self.loadMetaDocPrefixMapping();
            } else {
              self.$swal.fire({ icon: 'error', title: 'Error', text: (res && res.message) || 'Failed to deactivate category', timer: 2500 });
            }
          },
          function (err) {
            if (self.kccPopupShown(err)) return;
            self.$swal.fire({ icon: 'error', title: 'Error', text: (err && err.response && err.response.data && err.response.data.message) || 'Failed to deactivate category', timer: 2500 });
          }
        );
      }
    },
    viewMetaDocSubCategories(item) {
      this.selectedMetaDocCategory = item;
      this.metaDocCategorySubCategories = [];
      this.metaDocSubCategoriesDialog = true;
      this.loadMetaDocSubCategoriesByCategory(item.title);
    },
    closeMetaDocSubCategoriesDialog() {
      this.metaDocSubCategoriesDialog = false;
      this.selectedMetaDocCategory = null;
      this.metaDocCategorySubCategories = [];
    },
    loadMetaDocSubCategoriesByCategory(categoryTitle) {
      var self = this;
      self.loadingMetaDocSubCategories = true;
      self.kccSrc.GetMetaDocSubCategoriesByCategory(
        categoryTitle,
        function (res) {
          self.metaDocCategorySubCategories = (res && res.status === 0 && res.data) ? res.data : [];
          self.loadingMetaDocSubCategories = false;
        },
        function () {
          self.metaDocCategorySubCategories = [];
          self.loadingMetaDocSubCategories = false;
        }
      );
    },
    openMetaDocSubCategoryDialog(item) {
      this.metaDocSubCategoryEditMode = !!item;
      if (item) {
        this.metaDocSubCategoryFormData = Object.assign({}, item);
      } else {
        this.metaDocSubCategoryFormData = {
          id: 0,
          categoryTitle: this.selectedMetaDocCategory ? this.selectedMetaDocCategory.title : '',
          key: '',
          code: '',
          displayOrder: 0,
          isActive: true,
        };
      }
      this.metaDocSubCategoryDialog = true;
    },
    closeMetaDocSubCategoryDialog() {
      this.metaDocSubCategoryDialog = false;
      if (this.$refs.metaDocSubCategoryForm) this.$refs.metaDocSubCategoryForm.resetValidation();
    },
    saveMetaDocSubCategory() {
      var self = this;
      if (!self.metaDocSubCategoryFormValid) return;
      self.savingMetaDocSubCategory = true;
      var done = function (res) {
        self.savingMetaDocSubCategory = false;
        if (res && res.status === 0) {
          self.$swal.fire({ icon: 'success', title: self.metaDocSubCategoryEditMode ? 'Subcategory updated' : 'Subcategory created', showConfirmButton: false, timer: 1500 });
          self.closeMetaDocSubCategoryDialog();
          if (self.selectedMetaDocCategory) self.loadMetaDocSubCategoriesByCategory(self.selectedMetaDocCategory.title);
          self.loadMetaDocCategories();
          self.loadMetaDocPrefixMapping();
        } else {
          self.$swal.fire({ icon: 'error', title: 'Error', text: (res && res.message) || 'Failed to save subcategory', timer: 2000 });
        }
      };
      var fail = function (err) {
        self.savingMetaDocSubCategory = false;
        if (self.kccPopupShown(err)) return;
        self.$swal.fire({ icon: 'error', title: 'Error', text: (err && err.response && err.response.data && err.response.data.message) || 'Failed to save subcategory', timer: 2000 });
      };
      if (self.metaDocSubCategoryEditMode) {
        self.kccSrc.UpdateMetaDocSubCategory(self.metaDocSubCategoryFormData.id, self.metaDocSubCategoryFormData, done, fail);
      } else {
        self.kccSrc.CreateMetaDocSubCategory(self.metaDocSubCategoryFormData, done, fail);
      }
    },
    async confirmDeleteMetaDocSubCategory(item) {
      var self = this;
      var confirmed = await self.$swal.fire({
        title: 'Are you sure?',
        text: 'Deactivate subcategory: ' + item.key + '?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, deactivate it!',
      });
      if (confirmed.isConfirmed) {
        self.kccSrc.DeleteMetaDocSubCategory(
          item.id,
          function (res) {
            if (res && res.status === 0) {
              self.$swal.fire({ icon: 'success', title: 'Subcategory deactivated', showConfirmButton: false, timer: 1500 });
              if (self.selectedMetaDocCategory) self.loadMetaDocSubCategoriesByCategory(self.selectedMetaDocCategory.title);
              self.loadMetaDocCategories();
              self.loadMetaDocPrefixMapping();
            } else {
              self.$swal.fire({ icon: 'error', title: 'Error', text: (res && res.message) || 'Failed to deactivate subcategory', timer: 2500 });
            }
          },
          function (err) {
            if (self.kccPopupShown(err)) return;
            self.$swal.fire({ icon: 'error', title: 'Error', text: (err && err.response && err.response.data && err.response.data.message) || 'Failed to deactivate subcategory', timer: 2500 });
          }
        );
      }
    }
  },

  created() {
    // แหล่งข้อมูลของหน้า: อ่าน centerMode ทุกครั้งที่เรียก ⇒ สลับโหมดหลัง mounted ได้ · โหมดปกติ = $call เดิมทุกบรรทัด
    this.kccSrc = createMetaDocSource({
      call: this.$call,
      isCenter: () => this.centerMode,
      t: (k, p) => this.$t(k, p),
      swal: this.$swal,
    });
  },
  async mounted() {
    this.GetDate();
    // โหมด App Knowledge Center — ต้องรู้โหมดก่อนโหลด prefix mapping (โหมด Center ได้หมวดจาก Center ผ่าน kccSrc)
    // fail-soft: status พลาด/ปิดโหมด ⇒ หน้าเดิม
    this.kccStatus = await kccApi.status().catch(() => null);
    this.centerMode = !!(this.kccStatus && this.kccStatus.enabled);
    // โหมด Center แต่ไม่มี Admin key ⇒ ไม่ยิง Center เลย (แสดง alert ไปหน้าตั้งค่าแทน)
    if (!this.kccNotReady) await this.loadMetaDocPrefixMapping();
    const tab = this.$route.query.tab;
    const subTab = this.$route.query.subTab;
    if (tab && this.titleOptions.includes(tab)) {
      this.selectedTitle = tab;
      if (subTab) {
        this.selectedSubTitle = subTab;
      }
    }
    this._initialized = true;
    if (!this.kccNotReady) this.Get();
  },
  beforeDestroy() {
    // No need for debounce timers since filtering is handled in frontend
  },
};
</script>
<style scoped>
/* คอลัมน์ Product Type: tag หลายอันต่อแถว ห่อบรรทัดได้ ไม่ดันตารางกว้าง */
.type-tag-cell {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 4px 0;
}

.effective-date-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.date-row {
  display: flex;
  flex-direction: column;
}

.date-label {
  font-size: 11px;
  color: #666;
  text-transform: lowercase;
}

.date-value {
  font-size: 13px;
}

.card2 {
  border-radius: 16px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.card {
  border-radius: 16px !important;
  margin-bottom: 2rem;
  height: 90vh;
  overflow: auto;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.wrap-text {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/* Minimal Status Badge */
.status-badge {
  position: relative;
}

/* Minimal Reprocess Button */
.minimal-btn {
  border-radius: 50% !important;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.minimal-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.minimal-btn:disabled {
  opacity: 0.4;
  transform: none !important;
  box-shadow: none !important;
}

/* Action Divider */
.action-divider {
  width: 1px;
  height: 20px;
  background: rgba(0, 0, 0, 0.12);
  margin: 0 4px;
  align-self: center;
  border-radius: 1px;
}

.action-group:hover .action-divider {
  background: rgba(0, 0, 0, 0.2);
}

/* Table — Excel-like scroll */
.metadoc-table-container {
  overflow-x: auto;
  max-width: 100%;
  position: relative;
}

:deep(.metadoc-table) {
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.metadoc-table .v-table__wrapper) {
  max-height: 624px;
  overflow: auto !important;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.25) transparent;
}

:deep(.metadoc-table table) {
  min-width: 1610px;
  table-layout: fixed;
}

:deep(.metadoc-table .v-table__wrapper thead th) {
  background-color: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
}

/* Sticky Actions column (col 1, left: 0, width: 220px) */
:deep(.metadoc-table .v-table__wrapper table thead tr th:first-child),
:deep(.metadoc-table .v-table__wrapper table tbody tr td:first-child) {
  position: sticky !important;
  left: 0 !important;
  z-index: 1 !important;
  width: 220px !important;
  min-width: 220px !important;
  max-width: 220px !important;
}

:deep(.metadoc-table .v-table__wrapper table thead tr th:first-child) {
  top: 0 !important;
  background-color: #f5f5f5 !important;
  z-index: 3 !important;
}

:deep(.metadoc-table .v-table__wrapper table tbody tr td:first-child) {
  background-color: #fff !important;
}

/* Sticky ItemID column (col 2, left: 220px, width: 120px) */
:deep(.metadoc-table .v-table__wrapper table thead tr th:nth-child(2)),
:deep(.metadoc-table .v-table__wrapper table tbody tr td:nth-child(2)) {
  position: sticky !important;
  left: 220px !important;
  z-index: 1 !important;
  width: 120px !important;
  min-width: 120px !important;
  max-width: 120px !important;
}

:deep(.metadoc-table .v-table__wrapper table thead tr th:nth-child(2)) {
  top: 0 !important;
  background-color: #f5f5f5 !important;
  z-index: 3 !important;
}

:deep(.metadoc-table .v-table__wrapper table tbody tr td:nth-child(2)) {
  background-color: #fff !important;
}

/* Sticky Status column (col 3, left: 340px, width: 100px) */
:deep(.metadoc-table .v-table__wrapper table thead tr th:nth-child(3)),
:deep(.metadoc-table .v-table__wrapper table tbody tr td:nth-child(3)) {
  position: sticky !important;
  left: 340px !important;
  z-index: 1 !important;
  width: 100px !important;
  min-width: 100px !important;
  max-width: 100px !important;
}

:deep(.metadoc-table .v-table__wrapper table thead tr th:nth-child(3)) {
  top: 0 !important;
  background-color: #f5f5f5 !important;
  z-index: 3 !important;
}

:deep(.metadoc-table .v-table__wrapper table tbody tr td:nth-child(3)) {
  background-color: #fff !important;
}


:deep(.v-data-table tbody tr) {
  transition: background-color 0.2s ease;
}

:deep(.v-data-table tbody tr:hover) {
  background-color: rgba(0, 0, 0, 0.02) !important;
}

:deep(.metadoc-table .v-table__wrapper table tbody tr:hover td:first-child),
:deep(.metadoc-table .v-table__wrapper table tbody tr:hover td:nth-child(2)),
:deep(.metadoc-table .v-table__wrapper table tbody tr:hover td:nth-child(3)) {
  background-color: #fafafa !important;
}

:deep(.v-data-table-header) {
  background: rgba(0, 0, 0, 0.02);
}

:deep(.v-data-table-header th) {
  font-weight: 600 !important;
  color: rgba(0, 0, 0, 0.7) !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.025em !important;
}

/* Search panel improvements */
.search-panel {
  border: 1px solid rgba(0, 0, 0, 0.06) !important;
  border-radius: 12px !important;
  background: rgba(0, 0, 0, 0.01);
}

/* Header improvements */
:deep(.v-toolbar) {
  border-radius: 12px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12) !important;
}
.action-group {
  background: none;
  display: flex;
  align-items: center;
  gap: 14px;
}

/* Responsive design */
@media (max-width: 768px) {
  .action-group {
    flex-direction: column;
    gap: 2px;
    padding: 2px;
  }

  .action-btn {
    width: 32px;
    height: 32px;
  }
}

/* Smooth animations */
* {
  transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
}

/* Loading states */
.v-skeleton-loader {
  border-radius: 12px !important;
}

/* Focus states */
.action-btn:focus-visible {
  outline: 2px solid rgb(25, 118, 210);
  outline-offset: 2px;
}

/* Custom scrollbar */
:deep(.metadoc-table .v-table__wrapper)::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

:deep(.metadoc-table .v-table__wrapper)::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

:deep(.metadoc-table .v-table__wrapper)::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.25);
  border-radius: 4px;
}

:deep(.metadoc-table .v-table__wrapper)::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.35);
}

/* Action Controls */
.action-controls {
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 12px;
  padding: 4px 8px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
  min-width: 200px;
}

.action-controls:hover {
  background: rgba(0, 0, 0, 0.03);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.refresh-btn {
  margin-left: 9px;
  opacity: 0.7;
}

.refresh-btn:hover {
  opacity: 1;
  background: rgba(0, 0, 0, 0.06) !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .action-controls {
    width: 100%;
    justify-content: space-between;
  }

  .control-btn {
    flex: 1;
    margin: 0 2px;
  }

  .status-chip {
    min-width: 70px;
    font-size: 0.7rem;
  }

  .status-text {
    font-size: 0.7rem;
  }
}

.status-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.status-chip {
  font-weight: 500 !important;
  border-radius: 8px !important;
  min-width: 80px;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.status-chip:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.status-text {
  font-size: 0.75rem;
  font-weight: 600;
  margin-left: 4px;
}

/* Status Colors */
.status-chip.v-chip--variant-flat.text-success {
  background: rgba(76, 175, 80, 0.1) !important;
  color: #388e3c !important;
  border: 1px solid rgba(76, 175, 80, 0.2);
}

.status-chip.v-chip--variant-flat.text-warning {
  background: rgba(255, 152, 0, 0.1) !important;
  color: #f57c00 !important;
  border: 1px solid rgba(255, 152, 0, 0.2);
}

.status-chip.v-chip--variant-flat.text-grey {
  background: rgba(158, 158, 158, 0.1) !important;
  color: #616161 !important;
  border: 1px solid rgba(158, 158, 158, 0.2);
}

/* Icon styling */
.status-chip .v-icon {
  opacity: 0.8;
}

/* Processing/Completed chip — tighter icon-text gap, a bit more inline padding */
.status-chip-processing {
  padding-inline: 10px !important;
}

.status-chip-processing .status-chip-icon {
  margin-right: 2px;
}

.status-chip-processing .status-text {
  margin-left: 0;
}

.personal-info-switch-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 36px;
}

.personal-switch {
  margin: 0 !important;
}

.personal-switch :deep(.v-switch__track) {
  opacity: 0.6;
}

.personal-switch :deep(.v-switch__thumb) {
  transition: all 0.2s ease;
}

.personal-icon {
  transition: all 0.3s ease;
  opacity: 0.7;
}

.personal-switch :deep(.v-input--error) {
  color: inherit !important;
}

/* Hover effects */
.personal-switch:hover .personal-icon {
  opacity: 1;
  transform: scale(1.1);
}

/* Page Title Styling */
.page-title {
  font-weight: 600;
  font-size: 24px;
  color: rgba(0, 0, 0, 0.87);
  text-align: left;
  display: flex;
  align-items: center;
  height: 100%;
  min-height: 48px;
}

/* New Component Styles */
.filter-btn {
  height: 48px;
  border-radius: 50% !important;
  box-shadow: 0 2px 4px rgba(75, 40, 105, 0.3);
  transition: all 0.2s ease;
}

.filter-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(75, 40, 105, 0.4);
}

.filter-drawer {
  box-shadow: -4px 0 12px rgba(0, 0, 0, 0.1);
}

.filter-drawer .v-card-title {
  background: rgba(0, 0, 0, 0.02);
  font-weight: 600;
}

/* Custom Search Field Styling */
.custom-search-field {
  height: 48px !important;
}

.custom-search-field :deep(.v-field) {
  border-radius: 16px 16px !important;
  height: 48px !important;
  border-color: #c9c9c9 !important;
}

.custom-search-field :deep(.v-field__outline) {
  border-color: #c9c9c9 !important;
}

.custom-search-field :deep(.v-field__outline__start),
.custom-search-field :deep(.v-field__outline__end) {
  border-color: #c9c9c9 !important;
}

.custom-search-field :deep(.v-field__input) {
  display: flex !important;
  align-items: center !important;
  min-height: 48px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.custom-search-field :deep(.v-field__prepend-inner) {
  display: flex !important;
  align-items: center !important;
  padding-left: 5px !important;
}

.custom-search-field :deep(.v-input__control) {
  height: 48px !important;
}

.custom-search-field :deep(.v-field__field) {
  height: 48px !important;
  display: flex !important;
  align-items: center !important;
}

/* Custom Document Button Styling */
.custom-document-btn {
  color: #ffff;
  text-transform: none;
  box-shadow: 0 2px 4px rgba(80, 72, 151, 0.3);
  border-radius: 16px !important;
  height: 48px !important;
  min-width: 170px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: linear-gradient(90deg, #504897 0%, #4b2667 100%);
}

.custom-document-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(80, 72, 151, 0.4);
}

.database-text {
  font-size: 18px;
  font-weight: 500;
  line-height: normal;
  padding-bottom: 4px;
}

/* Filter Drawer Full Page Overlay */
.filter-drawer-fullpage {
  position: fixed !important;
  top: 0 !important;
  right: 0 !important;
  height: 100vh !important;
  z-index: 1999 !important;
  border-radius: 16px 0 0 16px;
}
.filter-drawer-card {
  border-radius: 16px 0 0 16px;
}

.v-navigation-drawer__scrim {
  background-color: rgba(0, 0, 0, 0.9) !important;
  z-index: 1997 !important;
}

/* Filter Drawer Styling */
.drawer-icon {
  width: 24px;
  height: 24px;
}

.filter-section-title {
  color: #000000;
  font-size: 16px;
  font-weight: 700;
}

/* Custom Checkbox Styling */
.custom-checkbox {
  font-size: 14px;
}

.custom-checkbox :deep(.v-selection-control__wrapper) {
  color: inherit;
}

/* Custom Category Dropdown Styling */
.custom-category-dropdown {
  margin-bottom: 8px !important;
}

.custom-category-dropdown :deep(.v-field) {
  border-radius: 48px !important;
  border: 1px solid #c9c9c9 !important;
  background: white !important;
  transition: all 0.2s ease !important;
}

.custom-category-dropdown :deep(.v-field__outline) {
  display: none !important;
}

.custom-category-dropdown :deep(.v-field__input) {
  padding: 12px 16px !important;
  min-height: 48px !important;
  color: #000000 !important;
  font-size: 14px !important;
}

.custom-category-dropdown:hover :deep(.v-field) {
  border-color: #903f98 !important;
}

.custom-category-dropdown :deep(.v-field--focused) {
  border-color: #903f98 !important;
  box-shadow: 0 0 0 2px rgba(144, 63, 152, 0.1) !important;
}
.date-text {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
  font-weight: 400;
  white-space: nowrap;
}

.category-text {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
  font-weight: 400;
  padding: 4px 8px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.04);
}

/* Action Button Color Updates */
.action-buttons-group {
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
}

.action-btn {
  min-width: 36px !important;
  width: 36px;
  height: 36px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.action-btn .v-icon {
  font-size: 14px;
}

.action-btn:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}

.edit-btn:hover {
  background-color: rgba(0, 123, 255, 0.1) !important;
}

.download-btn:hover {
  background-color: rgba(40, 167, 69, 0.1) !important;
}

/* Disabled delete button — clearer visual cue */
.delete-btn.v-btn--disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}

/* Table Row Improvements */
:deep(.v-data-table tbody tr) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

::v-deep.v-switch--inset .v-switch__thumb {
  height: 26px !important;
  width: 28px !important;
  transform: none !important;
}

/* Custom inset switch styling */
::v-deep.toggle-switch.v-switch--inset .v-switch__track {
  width: 55px !important;
  height: 30px !important;
  background-color: #c2c2c2 !important;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  border: none !important;
  border-radius: 50px !important;
  min-width: none;
}
::v-deep.toggle-switch.v-switch--inset .v-selection-control--dirty .v-switch__thumb {
  background-color: #4e3982 !important;
}
::v-deep.toggle-switch.v-switch--inset .v-selection-control--dirty .v-switch__track {
  background-color: #ffffff !important;
  border: 1px solid #4e3982 !important;
}
.time-text {
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 2px;
}
.custom-rounded-table {
  border: 1px solid #f5f5f5 !important;
  border-radius: 16px !important;
}

.filter-drawer-fullpage {
  z-index: 8000 !important;
}

.card2 {
  overflow: visible !important;
}

.filter-drawer-card {
  overflow: visible !important;
}

.download-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Title Tabs Styling */
.title-tabs {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.title-tabs :deep(.v-tab) {
  text-transform: none !important;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0;
  min-width: auto;
  padding: 0 16px;
}

.title-tabs :deep(.v-tab--selected) {
  color: #4B2869 !important;
  font-weight: 600;
}

.title-tabs :deep(.v-tabs-slider) {
  color: #4B2869 !important;
}

:deep(.v-slide-group__prev),
:deep(.v-slide-group__next) {
  min-width: 32px;
}

/* SubTitle Chips Styling */
.subtitle-chips {
  padding: 4px 0;
}

.subtitle-chip {
  font-size: 13px !important;
  font-weight: 500 !important;
  text-transform: none !important;
}

.action-text-btn {
  text-transform: none !important;
  font-weight: 500;
  font-size: 13px;
  letter-spacing: 0;
  min-width: auto !important;
  padding: 0 8px !important;
}

.prompt-cell {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Add New Item Dialog */
.add-item-dialog-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.add-item-dialog-header {
  background: linear-gradient(90deg, #f8a4c8, #f8c0d8);
  padding: 16px 24px;
}

.add-item-dialog-header h2 {
  font-weight: 700;
  font-size: 20px;
  color: #000;
  margin: 0;
}

.product-language-image-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.product-language-image-field {
  min-width: 0;
}

.product-language-label {
  display: block;
  margin-bottom: 6px;
  color: #52627a;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0;
}

.product-language-upload-button {
  position: relative;
  display: flex;
  min-height: 118px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #64748b;
  font-size: 11px;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.product-language-upload-button-has-preview {
  display: block;
  overflow: hidden;
  padding: 0;
  border-style: solid;
  border-color: #d7deeb;
  background: #f8fbff;
}

.product-language-upload-button-has-preview:hover {
  border-color: #94a3b8;
  background: #f8fbff;
}

.product-language-upload-button:hover {
  border-color: #94a3b8;
  background: #f8fafc;
}

.product-language-upload-button .v-icon {
  color: #665e73;
}

.product-language-upload-copy {
  display: block;
  max-width: 190px;
  line-height: 1.35;
}

.product-language-upload-primary {
  color: #e83e78;
}

.product-language-upload-secondary {
  color: #64748b;
}

.product-image-upload-input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.product-image-preview-surface {
  width: 100%;
  height: 118px !important;
  object-fit: contain;
  background: #f8fbff;
}

.product-image-preview-overlay {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 7px 9px;
  background: linear-gradient(transparent, rgba(15, 23, 42, 0.82));
  color: #fff;
  font-size: 11px;
  text-align: left;
}

.product-image-preview-overlay small {
  color: #e2e8f0;
  white-space: nowrap;
}

.product-image-remove {
  position: absolute;
  top: 7px;
  right: 7px;
  display: flex;
  width: 28px;
  height: 28px;
  min-width: 28px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.94);
  color: #334155;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.24);
}

.product-image-remove:hover {
  background: #fff;
  color: #dc2626;
}

.product-image-remove:focus-visible {
  outline: 3px solid rgba(25, 118, 210, 0.35);
  outline-offset: 2px;
}

.product-tax-planning {
  margin-left: -8px;
}

.product-key-highlight-panel {
  padding: 0;
}

.product-key-highlight-title {
  margin-bottom: 6px;
  color: #52627a;
  font-size: 13px;
  font-weight: 400;
}

.product-key-highlight-tabs {
  display: flex;
  gap: 0;
  overflow: hidden;
  border: 1px solid #d1d5db;
  border-radius: 4px 4px 0 0;
  background: #f5f5f5;
}

.product-key-highlight-tab {
  flex: 1 1 0;
  min-width: 0;
  min-height: 40px;
  margin: 0;
  border: 0;
  border-bottom: 2px solid transparent;
  border-radius: 0;
  color: #737373;
  background: transparent;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease;
}

.product-key-highlight-tab:hover {
  color: #e83e78;
  background: #fff;
}

.product-key-highlight-tab:focus-visible {
  outline: 2px solid rgba(232, 62, 120, 0.35);
  outline-offset: -2px;
}

.product-key-highlight-tab-active {
  border-bottom-color: #e83e78;
  color: #e83e78;
  background: #fff;
}

.product-key-highlight-textarea :deep(.v-field) {
  border-top: 0 !important;
  border-radius: 0 0 4px 4px !important;
}

.product-key-highlight-textarea {
  margin-top: -1px;
}

@media (max-width: 640px) {
  .product-language-image-row {
    grid-template-columns: 1fr;
  }
}

/* Category/SubCategory Management Dialogs - matches AccountInfoManagement.vue's theme */
.category-dialog-card {
  border-radius: 16px !important;
}

.category-dialog-header {
  background: #eeeff3;
  padding: 20px 16px !important;
}

.category-header-icon-container {
  width: 48px;
  height: 48px;
  margin-right: 12px;
}

.category-icon-background {
  padding: 8px;
  gap: 10px;
  width: 46px;
  height: 46px;
  background: #dee7f3;
  backdrop-filter: blur(2px);
  border-radius: 100px;
  box-shadow: none;
}

.category-dialog-title {
  font-size: 1.25rem;
  color: #1f1f1f;
}

.category-dialog-subtitle {
  color: #898989;
  font-size: 0.875rem;
}

:global(.non-loop-time-picker) {
  display: flex;
  align-items: stretch;
  justify-content: center;
  gap: 8px;
  padding: 10px 12px;
}

:global(.non-loop-time-column) {
  display: flex;
  flex-direction: column;
  width: 54px;
  height: 180px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fff;
  scroll-snap-type: y proximity;
}

:global(.non-loop-time-column::-webkit-scrollbar) {
  width: 6px;
}

:global(.non-loop-time-column::-webkit-scrollbar-thumb) {
  background: #c7c7c7;
  border-radius: 8px;
}

:global(.non-loop-time-option) {
  min-height: 32px;
  border: 0;
  background: transparent;
  color: #333;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  scroll-snap-align: center;
}

:global(.non-loop-time-option:hover) {
  background: #f5f5f5;
}

:global(.non-loop-time-option-active) {
  background: #1976d2;
  color: #fff;
}

:global(.non-loop-time-separator) {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

:global(.side-by-side-datetime-menu) {
  width: auto !important;
  max-width: calc(100vw - 24px);
}

:global(.side-by-side-datetime-menu .dp__instance_calendar[role="document"]) {
  display: flex;
  align-items: stretch;
}

:global(.side-by-side-datetime-menu .dp__instance_calendar[role="document"] > .dp__menu_inner) {
  border-right: 1px solid #e0e0e0;
}

:global(.side-by-side-datetime-menu .non-loop-time-picker) {
  height: 100%;
  min-height: 306px;
  align-items: center;
}

@media (max-width: 600px) {
  :global(.side-by-side-datetime-menu) {
    width: var(--dp-menu-width) !important;
  }

  :global(.side-by-side-datetime-menu .dp__instance_calendar[role="document"]) {
    flex-direction: column;
  }

  :global(.side-by-side-datetime-menu .dp__instance_calendar[role="document"] > .dp__menu_inner) {
    border-right: 0;
    border-bottom: 1px solid #e0e0e0;
  }

  :global(.side-by-side-datetime-menu .non-loop-time-picker) {
    min-height: auto;
  }
}

</style>
